webpackJsonp([1],{

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(866)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Config = {
  API_ROOT: 'https://iwan.wanchain.org/api/',
  RECAPTCHA_SITE_KEY: '6LeyP5gUAAAAAJ7vMjI6YvKZYRZ9Kf8twTcSqX4j'
};

module.exports = Config;

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

exports.pattern = {
  username: /^[a-zA-Z][a-zA-Z0-9_]{3,15}$/, // 4到16位（字母，数字，下划线，首字母英文）
  password: /(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/, // 8-20位，包括至少1个大写字母，1个小写字母，1个数字
  projectname: /^[a-zA-Z0-9_]{1,16}$/, // 1到16位（字母，数字，下划线，减号）
  // for fuzzy search
  searchUsername: /^[a-zA-Z0-9_]{1,16}$/, // 1到16位（字母，数字，下划线）
}

exports.reqAnalyticTs = function (period, uid, apikey, network, tzofs) {
  this.period = period; // xxh, xxd
  this.uid = uid;
  this.apikey = apikey;
  this.network = network;
  this.tzofs = tzofs; // number
}

exports.reqAnalyticTopn = function (aspect, n, period, uid, apikey, network, tzofs) {
  this.aspect = aspect,
  this.n = n;
  this.period = period; // xxh, xxd
  this.uid = uid;
  this.apikey = apikey;
  this.network = network;
  this.tzofs = tzofs; // number
}

exports.pageDirection = {
  init: 0,
  prev: 1,
  next: 2,
  jump: 3
};

var resCode = {
  // common
  SUCCESS: 0,
  // account
  VERIFY_CODE_MISMATCH: 1,
  EMAIL_ALREADY_EXIST: 2,
  USERNAME_ALREADY_EXIST: 3,
  VERIFY_CODE_SENT: 4,
  SEND_VERIFY_CODE_FAIL: 5,
  USER_PASSWORD_MISMATCH: 6,
  USER_NOT_FOUND: 7,
  INVALID_TOKEN: 8,
  INVALID_RECAPTCHA: 9,
  ACCOUNT_ABNORMAL: 10,
  // project
  PROJECT_ALREADY_EXIST: 100,
  PROJECT_NOT_FOUND: 101,
  // other
  INVALID_PARAM: 200,
  NO_MORE_DATA: 201,
  //
  UNKNOWN_ERROR: 1000
};
exports.resCode = resCode;

exports.resBody = function (code) {
  this.CODE = (typeof code !== 'undefined') ? code: resCode.SUCCESS;
  this.DATA = null;
}


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(193);

var _axios2 = _interopRequireDefault(_axios);

var _resources = __webpack_require__(531);

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  register: function register(data) {
    return _axios2.default.post(_resources2.default.register, data);
  },
  getVerifyCode: function getVerifyCode(data) {
    return _axios2.default.post(_resources2.default.getVerifyCode, data);
  },
  deregister: function deregister(data) {
    return _axios2.default.post(_resources2.default.deregister, data);
  },
  login: function login(data) {
    return _axios2.default.post(_resources2.default.login, data);
  },
  identify: function identify(data) {
    return _axios2.default.post(_resources2.default.identify, data);
  },
  getUser: function getUser(data) {
    return _axios2.default.post(_resources2.default.getUser, data);
  },
  changePassword: function changePassword(data) {
    return _axios2.default.post(_resources2.default.changePassword, data);
  },
  resetPassword: function resetPassword(data) {
    return _axios2.default.post(_resources2.default.resetPassword, data);
  },
  changeEmail: function changeEmail(data) {
    return _axios2.default.post(_resources2.default.changeEmail, data);
  },
  logout: function logout(data) {
    return _axios2.default.post(_resources2.default.logout, data);
  },
  checkUserExist: function checkUserExist(data) {
    return _axios2.default.post(_resources2.default.checkUserExist, data);
  },
  createProject: function createProject(data) {
    return _axios2.default.post(_resources2.default.createProject, data);
  },
  modifyProject: function modifyProject(data) {
    return _axios2.default.post(_resources2.default.modifyProject, data);
  },
  deleteProject: function deleteProject(data) {
    return _axios2.default.post(_resources2.default.deleteProject, data);
  },
  getProjects: function getProjects(data) {
    return _axios2.default.post(_resources2.default.getProjects, data);
  },
  getEndpoints: function getEndpoints(data) {
    return _axios2.default.post(_resources2.default.getEndpoints, data);
  },
  checkProjectExist: function checkProjectExist(data) {
    return _axios2.default.post(_resources2.default.checkProjectExist, data);
  },
  timeSeries: function timeSeries(data) {
    return _axios2.default.post(_resources2.default.timeSeries, data);
  },
  topn: function topn(data) {
    return _axios2.default.post(_resources2.default.topn, data);
  },
  getTotalCount: function getTotalCount(data) {
    return _axios2.default.post(_resources2.default.getTotalCount, data);
  },
  getUsers: function getUsers(data) {
    return _axios2.default.post(_resources2.default.getUsers, data);
  },
  search: function search(data) {
    return _axios2.default.post(_resources2.default.search, data);
  },
  setUser: function setUser(data) {
    return _axios2.default.post(_resources2.default.setUser, data);
  },
  setProject: function setProject(data) {
    return _axios2.default.post(_resources2.default.setProject, data);
  }
};

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(874)
__webpack_require__(875)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  "data-v-876916d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(873)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(100);

var _extends3 = _interopRequireDefault(_extends2);

var _en = __webpack_require__(844);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _extends3.default)({
    common: {
        submit: 'Submit',
        cancel: 'Cancel',
        sendCode: 'Send Code',
        verifyCode: 'Verification Code',
        reminder: 'Reminder',
        operation: 'Operation',
        statusNormal: "normal",
        statusDisabled: "disabled",

        sendCodeTip: 'We will send verification code to the email.',
        sendCodeSuccess: 'Sent verification code successfully',
        codeSent: 'Verification code has been sent, please resend after 5 minutes',
        sendCodeFail: 'sent verification code unsuccessfully, please try later',
        emailNotRegister: 'The email is not registered',
        usernameRequried: 'Username is required',
        usernameFormat: 'Username is 4-16 characters, including letter, number and underscore, starts with letter',
        emailRequried: 'Email is required',
        emailFormat: 'Please input a valid email',
        verifyCodeRequried: 'Verification code is required',
        verifyCodeFormat: 'Please input a valid verification code',
        veriryCodeMismatch: 'Incorrect or expired verification code',
        passwordRequried: 'Password is required',
        passwordFormat: 'Password is 8-20 characters, contains at least upper/lowercase letters and number',
        noData: 'Temporarily no data',
        tyrLater: 'Service is unavailable, please try again later',
        copySuccess: 'Copy success',
        copyFailed: 'Copy failed'
    },
    index: {
        documentation: 'Documentation',
        login: 'Log In',
        signup: 'Sign Up',
        logout: 'Log Out',
        lang: '中文',
        gatewayTitle: 'Gateway to the Wanchain Network',
        gatewayInfo: 'Our easy to use API provides users with secure and dependable access to the full array of Wanchain node services. iWan allows you to focus on building great decentralized applications, while the infrastructure is managed for you.',
        benefitTitle: 'WHY CHOOSE IWAN',
        benefit1: 'NO MORE SELF-HOSTED NODES',
        benefit1info: 'We eliminate the need to install, configure, and maintain costly blockchain infrastructure.',
        benefit2: 'RELIABLE AND FAST TO DEPLOY',
        benefit2info: 'Our RPC server offers top-tier reliability and helps you quickly deploy your application.',
        benefit3: 'CROSS-CHAIN ABILITY',
        benefit3info: 'Access Cross-chain ability seamlessly without the hassle of managing the infrastructure for different blockchains.',
        summary: 'EFFORTLESSLY ACCESS WANCHAIN\'S CROSS-CHAIN ECOSYSTEM',
        copyright: '©WANCHAIN FOUNDATION LTD 2019 all rights reserved',

        logoutWndInfo: 'Are you sure to log out?'
    },
    signup: {
        title: 'Get Started for Free',
        username: 'Username',
        email: 'Email Address',
        password: 'Password',
        confirm: 'Confirm Password',
        signup: 'Sign Up',
        privacyBegin: 'Signing up signifies you have read and agree to the',
        service: 'Terms of Service',
        privacyAnd: ' and',
        privacy: 'Privacy Policy',
        privacyEnd: '.',
        haveAccount: 'Already have an account?',
        login: 'Log In',

        usernameUsed: 'Username has been used',
        emailUsed: 'Email has been registered',
        confirmPwdRequried: 'Confirm password is required',
        confirmPwdMismatch: 'Password and confirm password don\'t match',
        registerSuccess: 'Register successfully'
    },
    login: {
        title: 'Log In to Your Account',
        user: 'Username / Email',
        password: 'Password',
        login: 'Log In',
        forgotPwd: 'Forgot Your Password?',
        notMember: 'Not a member yet?',
        signup: 'Sign Up',

        emailNameRequired: 'Email or username is required',
        emailNameFormat: 'Please input a valid username or email',
        incorrectPwd: 'Incorrect username/email or password',
        accountAbnormal: 'Account abnormal, please contact administrator'
    },
    resetPwd: {
        title: 'Reset Password',
        email: 'Email Address',
        reset: 'Reset Password',
        back: 'Back to',
        login: 'Log In',

        mailReminder: 'A temporary password was sent to your email, please log in with it and change the password'
    },
    projectManage: {
        title: 'Project Management',
        create: 'Create Project',
        edit: 'Edit',
        delete: 'Delete',
        name: 'PROJECT NAME',
        apikey: 'API KEY',
        secret: 'SECRET KEY',
        serviceType: 'SERVICE TYPE',
        status: 'STATUS',
        createDate: 'CREATION DATE',
        operation: 'OPERATION',

        endpoint: 'Endpoint',

        createWndTitle: 'Create',
        createWndName: 'NAME',

        editWndTitle: 'Edit',
        editWndName: 'NAME',

        deleteWndInfo: 'Are you sure to delete this project?',

        nameRequired: 'Input project name',
        nameFormat: '1-16 characters, including letter, number and underscore',
        nameUsed: 'Project name has been used',
        deleteSuccess: 'Delete project successfully',
        editSuccess: 'Modify project successfully',
        createSuccess: 'Create project successfully'
    },
    accountManage: {
        title: 'My Account',
        accountInfo: 'Account Information',
        changePwd: 'Change Password',
        changeEmail: 'Change Email Address'
    },
    accountInfo: {
        title: 'Account Information',
        username: 'User Name',
        email: 'Email Address',
        role: 'Role',
        level: 'Level',
        status: 'Status',
        registerDate: 'Registration Date',
        lastDate: 'Last Login Date',
        lastIp: 'Last Login IP'
    },
    changePwd: {
        title: 'Change Password',
        oldPassword: 'Input Old Password',
        newPassword: 'Input New Password',
        retypePassword: 'Retype New Password',

        oldPwdRequried: 'Input Current Password',
        newPwdRequried: 'Input New Password',
        confirmNewPwd: 'Confirm New Password',
        confirmNewPwdMismatch: 'The new password and confirm password do not match',
        changeSuccess: 'Change password successfully',
        oldPwdIncorrect: 'The old password is incorrect'
    },
    changeEmail: {
        title: 'Change Email Address',
        password: 'Input Password',
        newEmail: 'New Email Address',

        changeSuccess: 'Change email successfully',
        pwdIncorrect: 'The password is incorrect'
    },
    admin: {
        title: 'Administrator',
        users: 'Users',
        projects: 'Projects',
        totalUsers: 'Total users:',
        totalProjects: ', total projects:',
        searchUser: 'Search by Username / Email',
        searchProject: 'Search by Username / Email / API key'
    },
    stats: {
        title: 'Statistics',
        allProjects: 'All Projects',
        last24h: 'Last 24 Hours',
        last7d: 'Last 7 Days',
        last30d: 'Last 30 Days',
        totalMethodCalls: 'Total Method Calls',
        projectMethodCalls: 'Project Method Calls',
        topnMethodCalls: 'Method Calls ',
        topnMethodCallsSummary: 'summary',
        chartHeatmap: 'Calls Heatmap'
    }
}, _en2.default);

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(100);

var _extends3 = _interopRequireDefault(_extends2);

var _zhCN = __webpack_require__(280);

var _zhCN2 = _interopRequireDefault(_zhCN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _extends3.default)({
    common: {
        submit: '提交',
        cancel: '取消',
        sendCode: '发送验证码',
        verifyCode: '验证码',
        reminder: '提示',
        operation: '操作',
        statusNormal: "正常",
        statusDisabled: "禁用",

        sendCodeTip: '',
        sendCodeSuccess: '验证码发送成功',
        codeSent: '验证码已发送，请5分钟后重新发送',
        sendCodeFail: '验证码发送失败，请稍后再试',
        emailNotRegister: '电子邮件未注册',
        usernameRequried: '请输入用户名',
        usernameFormat: '用户名为4-16个字符，包括字母、数字和下划线，以字母开头',
        emailRequried: '请输入电子邮件',
        emailFormat: '请输入有效的邮件地址',
        verifyCodeRequried: '请输入验证码',
        verifyCodeFormat: '请输入有效的验证码',
        veriryCodeMismatch: '验证码不正确或已过期',
        passwordRequried: '请输入密码',
        passwordFormat: '密码为8-20个字符，至少包含大小写字母和数字',
        noData: '暂无数据',
        tyrLater: '无可用服务，请稍后再试',
        copySuccess: '复制成功',
        copyFailed: '复制失败'
    },
    index: {
        documentation: '文档',
        login: '登录',
        signup: '注册',
        logout: '退出',
        lang: 'English',
        gatewayTitle: 'Wanchain网络之门',
        gatewayInfo: 'iWan易用的API助您安全可靠地访问Wanchain的完整节点服务。 我们为您管理区块链基础架构，使您能专注于构建优秀的分布式应用。',
        benefitTitle: '为什么选择IWAN',
        benefit1: '无需自行维护节点',
        benefit1info: '不再需要安装、配置和维护昂贵的区块链基础设施。',
        benefit2: '可靠、快速部署',
        benefit2info: '我们的RPC服务器提供业界顶尖的可靠性，助您快速部署应用。',
        benefit3: '跨链能力',
        benefit3info: '无缝调用跨链能力，无需管理不同区块链的基础架构。',
        summary: '轻松访问Wanchain的跨链生态系统',
        copyright: '版权所有©2019年 WANCHAIN FOUNDATION LTD',

        logoutWndInfo: '确认退出登录？'
    },
    signup: {
        title: '免费开始您的iWan之旅',
        username: '用户名',
        email: '邮件地址',
        password: '密码',
        confirm: '确认密码',
        signup: '注册',
        privacyBegin: '注册即表示您已阅读并同意',
        service: '服务条款',
        privacyAnd: ' 和',
        privacy: '隐私政策',
        privacyEnd: '。',
        haveAccount: '已经有账号？',
        login: '登录',

        usernameUsed: '用户名已被使用',
        emailUsed: '邮件地址已注册',
        confirmPwdRequried: '请输入确认密码',
        confirmPwdMismatch: '密码和确认密码不匹配',
        registerSuccess: '注册成功'
    },
    login: {
        title: '请使用iWan账号登录',
        user: '用户名 / 邮件地址',
        password: '密码',
        login: '登录',
        forgotPwd: '忘记密码？',
        notMember: '还没有账号？',
        signup: '注册',

        emailNameRequired: '请输入用户名或电子邮件',
        emailNameFormat: '请输入有效的用户名或邮件地址',
        incorrectPwd: '用户名/电子邮件或密码错误',
        accountAbnormal: '账户异常，请联系管理员'
    },
    resetPwd: {
        title: '重置密码',
        email: '邮件地址',
        reset: '重置密码',
        back: '回到',
        login: '登录',

        mailReminder: '临时密码已发送到您的电子邮件，请使用它登录并更改密码'
    },
    projectManage: {
        title: '项目管理',
        create: '新建项目',
        edit: '编辑',
        delete: '删除',
        name: '项目名称',
        apikey: 'API KEY',
        secret: 'SECRET KEY',
        serviceType: '服务类型',
        status: '状态',
        createDate: '创建时间',
        operation: '操作',

        endpoint: '节点',

        createWndTitle: '新建',
        createWndName: '名称',

        editWndTitle: '编辑',
        editWndName: '名称',

        deleteWndInfo: '确认删除此项目？',

        nameRequired: '输入项目名称',
        nameFormat: '1-16个字符，包括字母、数字和下划线',
        nameUsed: '项目名称已被使用',
        deleteSuccess: '删除项目成功',
        editSuccess: '修改项目成功',
        createSuccess: '新建项目成功'
    },
    accountManage: {
        title: '我的账号',
        accountInfo: '账号信息',
        changePwd: '修改密码',
        changeEmail: '修改邮件地址'
    },
    accountInfo: {
        title: '账号信息',
        username: '用户名',
        email: '邮件地址',
        role: '角色',
        level: '级别',
        status: '状态',
        registerDate: '注册时间',
        lastDate: '上次登录时间',
        lastIp: '上次登录IP'
    },
    changePwd: {
        title: '修改密码',
        oldPassword: '旧密码',
        newPassword: '新密码',
        retypePassword: '确认新密码',

        oldPwdRequried: '输入当前密码',
        newPwdRequried: '输入新密码',
        confirmNewPwd: '确认新密码',
        confirmNewPwdMismatch: '新密码和确认密码不匹配',
        changeSuccess: '修改密码成功',
        oldPwdIncorrect: '旧密码不正确'
    },
    changeEmail: {
        title: '修改邮件地址',
        password: '密码',
        newEmail: '新邮件地址',

        changeSuccess: '修改邮件地址成功',
        pwdIncorrect: '密码不正确'
    },
    admin: {
        title: '管理员',
        users: '用户管理',
        projects: '项目管理',
        totalUsers: '用户总数：',
        totalProjects: '，项目总数：',
        searchUser: '搜索用户名/邮箱',
        searchProject: '搜索用户名/邮箱/API key'
    },
    stats: {
        title: '统计',
        allProjects: '所有项目',
        last24h: '最近24小时',
        last7d: '最近7天',
        last30d: '最近30天',
        totalMethodCalls: '总调用次数',
        projectMethodCalls: '项目调用次数',
        topnMethodCalls: '方法调用 ',
        topnMethodCallsSummary: '汇总',
        chartHeatmap: '调用次数热力图'
    }
}, _zhCN2.default);

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(968);

var _Login2 = _interopRequireDefault(_Login);

var _Register = __webpack_require__(970);

var _Register2 = _interopRequireDefault(_Register);

var _FgtPwd = __webpack_require__(967);

var _FgtPwd2 = _interopRequireDefault(_FgtPwd);

var _Terms = __webpack_require__(971);

var _Terms2 = _interopRequireDefault(_Terms);

var _Privacy = __webpack_require__(969);

var _Privacy2 = _interopRequireDefault(_Privacy);

var _ = __webpack_require__(957);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(963);

var _Home2 = _interopRequireDefault(_Home);

var _Index = __webpack_require__(964);

var _Index2 = _interopRequireDefault(_Index);

var _AccountInformation = __webpack_require__(958);

var _AccountInformation2 = _interopRequireDefault(_AccountInformation);

var _ChangePassword = __webpack_require__(960);

var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

var _ChangeEmailAddress = __webpack_require__(959);

var _ChangeEmailAddress2 = _interopRequireDefault(_ChangeEmailAddress);

var _ProjectManagement = __webpack_require__(965);

var _ProjectManagement2 = _interopRequireDefault(_ProjectManagement);

var _Statistics = __webpack_require__(966);

var _Statistics2 = _interopRequireDefault(_Statistics);

var _Users = __webpack_require__(962);

var _Users2 = _interopRequireDefault(_Users);

var _Projects = __webpack_require__(961);

var _Projects2 = _interopRequireDefault(_Projects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
  path: "/login",
  component: _Login2.default,
  name: "login",
  hidden: true
}, {
  path: "/register",
  component: _Register2.default,
  name: "register",
  hidden: true
}, {
  path: "/forgotpassword",
  component: _FgtPwd2.default,
  name: "forgotpassword",
  hidden: true
}, {
  path: "/terms",
  component: _Terms2.default,
  name: "terms",
  hidden: true
}, {
  path: "/privacy",
  component: _Privacy2.default,
  name: "privacy",
  hidden: true
}, {
  path: "/404",
  component: _2.default,
  name: "",
  hidden: true
}, {
  path: "/",
  component: _Index2.default,
  name: "index",
  hidden: true
}, {
  path: "/ProjectManagement",
  component: _Home2.default,
  name: "",
  iconCls: "fa fa-address-card",
  leaf: true,
  children: [{
    path: "/ProjectManagement",
    component: _ProjectManagement2.default,
    name: "Project Management",
    title: "projectManage.title",
    meta: {
      requireAuth: true
    }
  }]
}, {
  path: "/AccountManagement",
  component: _Home2.default,
  title: "accountManage.title",
  iconCls: "fa el-icon-setting",
  children: [{
    path: "/AccountInformation",
    component: _AccountInformation2.default,
    name: "Account Information",
    title: "accountManage.accountInfo",
    meta: {
      requireAuth: true
    }
  }, {
    path: "/ChangePassword",
    component: _ChangePassword2.default,
    name: "Change Password",
    title: "accountManage.changePwd",
    meta: {
      requireAuth: true
    }
  }, {
    path: "/ChangeEmailAddress",
    component: _ChangeEmailAddress2.default,
    name: "Change Email Address",
    title: "accountManage.changeEmail",
    meta: {
      requireAuth: true
    }
  }]
}, {
  path: "/Admin",
  component: _Home2.default,
  title: "admin.title",
  iconCls: "fa fa-id-card-o",
  adminOnly: true,
  children: [{
    path: "/Users",
    component: _Users2.default,
    name: "Users",
    title: "admin.users",
    meta: {
      requireAuth: true
    }
  }, {
    path: "/Projects",
    component: _Projects2.default,
    name: "Projects",
    title: "admin.projects",
    meta: {
      requireAuth: true
    }
  }]
}, {
  path: "/Statistics",
  component: _Home2.default,
  name: "",
  iconCls: "fa el-icon-date",
  leaf: true,
  children: [{
    path: "/Statistics",
    component: _Statistics2.default,
    name: "Statistics",
    title: 'stats.title',
    meta: {
      requireAuth: true
    }
  }]
}, {
  path: "*",
  hidden: true,
  redirect: { path: "/404" }
}];

exports.default = routes;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(24);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(194);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(533);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(534);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(863)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(979),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "app",
  components: {}
};

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {}
};

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {}
};

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

var _utils = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resCode = __webpack_require__(25).resCode;

exports.default = {
  data: function data() {
    return {
      username: "",
      email: "",
      created: "",
      status: "",
      time: "",
      ip: ""
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    _api2.default.getUser({}).then(function (res) {
      if (res.data.CODE === resCode.SUCCESS) {
        var data = res.data.DATA;
        _this.username = data.username;
        _this.email = data.email;
        _this.created = (0, _utils.formatTime)(data.created, "YYYY-MM-DD HH:mm:ss");
        if (data.status === "disabled") {
          _this.status = _this.$t('common.statusDisabled');
        } else {
          _this.status = _this.$t('common.statusNormal');
        }
        if (data.trace !== null && data.trace.length >= 2) {
          var index = data.trace.length - 2;
          _this.time = (0, _utils.formatTime)(data.trace[index].time, "YYYY-MM-DD HH:mm:ss");
          _this.ip = (0, _utils.formatIp)(data.trace[index].ip);
        } else {
          _this.time = "";
          _this.ip = "";
        }
      }
    }).catch(function (err) {});
  }
};

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(63);

var _data = __webpack_require__(25);

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = __webpack_require__(123);

exports.default = {
  data: function data() {
    var _this = this;

    var validateEmail = function validateEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.emailRequried')));
      } else {
        if (validator.isEmail(value)) {
          _api2.default.checkUserExist({ email: value }).then(function (res) {
            if (res.data.CODE !== _data.resCode.USER_NOT_FOUND) {
              callback(new Error(_this.$t('signup.emailUsed')));
            } else {
              callback();
            }
          }).catch(function () {
            callback();
          });
        } else {
          callback(new Error(_this.$t('common.emailFormat')));
        }
      }
    };
    var validateCode = function validateCode(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.verifyCodeRequried')));
      } else {
        if (validator.isLength(value, { min: 6, max: 6 }) && validator.isAlphanumeric(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.verifyCodeFormat')));
        }
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.passwordRequried')));
      } else {
        if (_data.pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.passwordFormat')));
        }
      }
    };
    return {
      chgEmailForm: {
        pass: "",
        email: "",
        code: ""
      },
      chgEmailRule: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }]
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this2 = this;

      this.$refs.chgEmailForm.validate(function (valid) {
        if (valid) {
          var data = {
            password: _this2.chgEmailForm.pass,
            email: _this2.chgEmailForm.email,
            code: _this2.chgEmailForm.code
          };
          (0, _request.changeEmail)(_this2, data);
        } else {
          return false;
        }
      });
    },
    getVerifyCode: function getVerifyCode() {
      var _this3 = this;

      this.$refs.chgEmailForm.validateField("email", function (err) {
        if (!err) {
          var data = {
            email: _this3.chgEmailForm.email,
            act: "change email"
          };
          (0, _request.sendVerifyCode)(_this3, data);
        } else {
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(63);

var _data = __webpack_require__(25);

exports.default = {
  data: function data() {
    var _this = this;

    var validateOldPass = function validateOldPass(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('changePwd.oldPwdRequried')));
      } else {
        if (_data.pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.passwordFormat')));
        }
        callback();
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('changePwd.newPwdRequried')));
      } else {
        if (_data.pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.passwordFormat')));
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('changePwd.confirmNewPwd')));
      } else if (value !== _this.chgPwdForm.newPass) {
        callback(new Error(_this.$t('changePwd.confirmNewPwdMismatch')));
      } else {
        callback();
      }
    };
    return {
      chgPwdForm: {
        oldPass: "",
        newPass: "",
        checkPass: ""
      },
      chgPwdRule: {
        oldPass: [{ validator: validateOldPass, trigger: "blur" }],
        newPass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this2 = this;

      this.$refs.chgPwdForm.validate(function (valid) {
        if (valid) {
          var data = {
            password_old: _this2.chgPwdForm.oldPass,
            password_new: _this2.chgPwdForm.newPass
          };
          (0, _request.changePassword)(_this2, data);
        } else {
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

var _data = __webpack_require__(25);

var _utils = __webpack_require__(79);

var _clipboard = __webpack_require__(133);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      search: "",
      user: {},
      projects: [],
      listLoading: false
    };
  },

  methods: {
    projectStats: function projectStats(apikey) {
      this.$router.push({
        name: "Statistics",
        params: { apikey: apikey, username: this.user.username, uid: this.user.uid }
      });
    },
    setProject: function setProject(project) {
      _api2.default.setProject({
        apikey: project.apikey,
        status: project.status
      }).then(function (res) {}).catch(function () {});
    },
    copy: function copy(column, data) {
      var _this = this;

      var clipboard = new _clipboard2.default(".tag", {
        text: function text() {
          if (column === "apikey") {
            return data.apikey;
          } else {
            return data.secret;
          }
        }
      });
      clipboard.on("success", function (e) {
        _this.$message({ message: _this.$t("common.copySuccess"), showClose: true, type: "success" });

        clipboard.destroy();
      });
      clipboard.on("error", function (e) {
        _this.$message({ message: _this.$t("common.copyFailed"), showClose: true, type: "error" });
        clipboard.destroy();
      });
    },
    searchProject: function searchProject(key) {
      var _this2 = this;

      _api2.default.search({
        key: this.search
      }).then(function (res) {
        if (res.data.CODE === _data.resCode.SUCCESS) {
          _this2.user = res.data.DATA.user;
          _this2.user.created = (0, _utils.formatTime)(_this2.user.created, "YYYY-MM-DD HH:mm:ss");
          if (_this2.user.status === "disabled") {
            _this2.user.status = _this2.$t("common.statusDisabled");
          } else {
            _this2.user.status = _this2.$t("common.statusNormal");
          }
          _this2.projects = res.data.DATA.projects;
          _this2.projects.forEach(function (item) {
            item.created = (0, _utils.formatTime)(item.created, "YYYY-MM-DD HH:mm:ss");
          });
        } else {
          _this2.user = {};
          _this2.projects = [];
        }
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.search = this.$route.params.username;
    if (this.search) {
      this.searchProject(this.search);
    }
  }
};

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

var _data = __webpack_require__(25);

var _utils = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      totalUsers: 0,
      totalProjects: 0,
      search: "",
      pageSize: 10,
      users: [],
      total: 0,
      curPage: 1,
      lastPage: 1,
      listLoading: false
    };
  },

  methods: {
    getTotalCount: function getTotalCount() {
      var _this = this;

      _api2.default.getTotalCount().then(function (res) {
        if (res.data.CODE === _data.resCode.SUCCESS) {
          _this.totalUsers = res.data.DATA.totalUsers;
          _this.totalProjects = res.data.DATA.totalProjects;
        }
      }).catch(function () {});
    },
    userStats: function userStats(uid, username) {
      this.$router.push({ name: "Statistics", params: { uid: uid, username: username } });
    },
    projectList: function projectList(username) {
      this.$router.push({ name: "Projects", params: { username: username } });
    },
    handleCurrentChange: function handleCurrentChange(page, direction, last) {
      this.curPage = page;
      this.getUsers(this.search, this.total, page, direction, last);
      this.lastPage = page;
    },
    changePageSize: function changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.curPage = 1;
      this.lastPage = 1;
      this.jumpPage(1);
    },
    jumpPage: function jumpPage(page) {
      if (page === this.lastPage - 1) {
        this.handleCurrentChange(page, _data.pageDirection.prev, this.users[0].username);
      } else if (page === this.lastPage + 1) {
        this.handleCurrentChange(page, _data.pageDirection.next, this.users[this.users.length - 1].username);
      } else {
        this.handleCurrentChange(page, _data.pageDirection.jump, "");
      }
    },
    getUsers: function getUsers(search, total, page, direction, last) {
      var _this2 = this;

      this.listLoading = true;
      _api2.default.getUsers({ user: search, total: total, page: page, direction: direction, pagesize: this.pageSize, last: last }).then(function (res) {
        if (res.data.CODE === _data.resCode.SUCCESS || res.data.CODE === _data.resCode.NO_MORE_DATA) {
          _this2.users = res.data.DATA.users;
          _this2.total = res.data.DATA.total;
        } else {
          _this2.users = [];
          _this2.total = 0;
        }
        _this2.users.sort(function (a, b) {
          var la = a.username.toLowerCase();
          var lb = b.username.toLowerCase();
          if (la < lb) {
            return -1;
          } else if (la > lb) {
            return 1;
          } else {
            return 0;
          }
        });
        _this2.users.forEach(function (item) {
          item.created = (0, _utils.formatTime)(item.created, "YYYY-MM-DD HH:mm:ss");
        });
        _this2.listLoading = false;
      }).catch(function () {});
    },
    setUser: function setUser(user) {
      _api2.default.setUser({
        username: user.username,
        status: user.status
      }).then(function (res) {}).catch(function () {});
    },
    searchUser: function searchUser(key) {
      this.curPage = 1;
      this.getUsers(this.search, 0, 1, _data.pageDirection.init, "");
      this.lastPage = 1;
    },
    isDisableSw: function isDisableSw(user) {
      return user.role === "admin";
    }
  },
  mounted: function mounted() {
    this.getTotalCount();
    this.getUsers(this.search, 0, 1, _data.pageDirection.init, "");
  }
};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(63);

exports.default = {
  data: function data() {
    return {
      collapsed: false,
      isAdmin: false
    };
  },

  methods: {
    handleopen: function handleopen() {},
    handleclose: function handleclose() {},

    handleselect: function handleselect(a, b) {},
    logout: function logout() {
      var _this2 = this;

      var _this = this;
      this.$confirm(this.$t("index.logoutWndInfo"), this.$t("common.reminder"), {
        showCancelButton: true,
        confirmButtonText: this.$t("index.logout"),
        cancelButtonText: this.$t("common.cancel")
      }).then(function () {
        (0, _request.doLogout)(_this2, {});
      }).catch(function () {});
    },
    isVisible: function isVisible(item) {
      if (item.hidden) {
        return false;
      }
      if (item.adminOnly) {
        if (!this.isAdmin) {
          return false;
        }
      }
      return true;
    }
  },
  mounted: function mounted() {
    this.isAdmin = sessionStorage.getItem("role") === "admin";
  }
};

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(182);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    iFooter: _Footer2.default
  },
  methods: {
    langToggle: function langToggle() {
      if (this.$i18n.locale == "zh_CN") {
        this.$i18n.locale = "en_US";
      } else {
        this.$i18n.locale = "zh_CN";
      }
      localStorage.setItem("locale", this.$i18n.locale);
    }
  }
};

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(202);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

var _data = __webpack_require__(25);

var _clipboard = __webpack_require__(133);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _this = this;

    var validateName = function validateName(rule, value, cb) {
      if (value === "") {
        cb(new Error(_this.$t("projectManage.nameRequired")));
      } else if (!_data.pattern.projectname.test(value)) {
        cb(new Error(_this.$t("projectManage.nameFormat")));
      } else {
        _api2.default.checkProjectExist({ name: value }).then(function (res) {
          if (res.data.CODE !== _data.resCode.PROJECT_NOT_FOUND) {
            cb(new Error(_this.$t("projectManage.nameUsed")));
          } else {
            cb();
          }
        }).catch(function () {
          cb();
        });
      }
    };
    return {
      networks: [],
      network: "",
      endpoints: {},
      endpoint: "",
      projects: [],
      listLoading: false,


      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        name: [{ validator: validateName, trigger: "blur" }]
      },

      editForm: {
        name: "",
        apikey: "",
        secret: ""
      },

      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ validator: validateName, trigger: "blur" }]
      },

      addForm: {
        name: "",
        apikey: "",
        secret: ""
      }
    };
  },

  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getProjects();
    },
    getProjects: function getProjects() {
      var _this2 = this;

      this.listLoading = true;
      _api2.default.getProjects({}).then(function (res) {
        if (res.data.CODE === _data.resCode.SUCCESS) {
          _this2.projects = res.data.DATA;
        } else {
          _this2.projects = [];
        }
        _this2.listLoading = false;
      }).catch(function () {});
    },

    handleDel: function handleDel(index, row) {
      var _this3 = this;

      this.$confirm(this.$t("projectManage.deleteWndInfo"), this.$t("common.reminder"), {
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("common.submit"),
        cancelButtonText: this.$t("common.cancel")
      }).then(function () {
        _this3.listLoading = true;

        _api2.default.deleteProject({ apikey: row.apikey }).then(function (res) {
          _this3.listLoading = false;

          _this3.$message({
            message: _this3.$t("projectManage.deleteSuccess"),
            type: "success"
          });
          _this3.getProjects();
        }).catch(function () {});
      }).catch(function () {});
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
    },

    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        apikey: "",
        secret: ""
      };
    },

    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this4.editLoading = true;
          var para = {
            apikey: _this4.editForm.apikey,
            name: _this4.editForm.name
          };
          _api2.default.modifyProject(para).then(function (res) {
            _this4.editLoading = false;
            _this4.$message({
              message: _this4.$t("projectManage.editSuccess"),
              type: "success"
            });
            _this4.$refs["editForm"].resetFields();
            _this4.editFormVisible = false;
            _this4.getProjects();
          }).catch(function () {});
        }
      });
    },

    addSubmit: function addSubmit() {
      var _this5 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this5.addLoading = true;
          _api2.default.createProject({ name: _this5.addForm.name }).then(function (res) {
            _this5.addLoading = false;
            _this5.$message({
              message: _this5.$t("projectManage.createSuccess"),
              type: "success"
            });
            _this5.$refs["addForm"].resetFields();
            _this5.addFormVisible = false;
            _this5.getProjects();
          }).catch(function () {});
        }
      });
    },
    copy: function copy(column, data) {
      var _this6 = this;

      var clipboard = new _clipboard2.default(".tag", {
        text: function text() {
          if (column === "apikey") {
            return data.apikey;
          } else {
            return data.secret;
          }
        }
      });
      clipboard.on("success", function (e) {
        _this6.$message({ message: _this6.$t("common.copySuccess"), showClose: true, type: "success" });

        clipboard.destroy();
      });
      clipboard.on("error", function (e) {
        _this6.$message({ message: _this6.$t("common.copyFailed"), showClose: true, type: "error" });
        clipboard.destroy();
      });
    },
    getEndpoints: function getEndpoints(apikey) {
      var _this7 = this;

      _api2.default.getEndpoints({ apikey: apikey }).then(function (res) {
        if (res.data.CODE === _data.resCode.SUCCESS) {
          _this7.endpoints = res.data.DATA;
          for (var name in _this7.endpoints) {
            _this7.networks.push({ value: name, label: name });
          }

          _this7.network = _this7.networks[0].value;
          _this7.selectNetwork(_this7.network);
        } else {
          _this7.endpoints = {};
          _this7.networks = [];
        }
      }).catch(function () {});
    },
    selectNetwork: function selectNetwork(select) {
      this.endpoint = this.endpoints[select] + "YOUR-API-KEY";
    }
  },
  mounted: function mounted() {
    this.getProjects();
    this.getEndpoints("");
  }
};

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(201);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      sitekey: _config2.default.RECAPTCHA_SITE_KEY,
      widgetId: 0
    };
  },

  methods: {
    execute: function execute() {
      window.grecaptcha.execute(this.widgetId);
    },
    reset: function reset() {
      window.grecaptcha.reset(this.widgetId);
    },
    render: function render() {
      var _this = this;

      if (window.grecaptcha) {
        this.widgetId = window.grecaptcha.render('g-recaptcha', {
          sitekey: this.sitekey,
          size: 'invisible',

          callback: function callback(response) {
            _this.$emit('verify', response);

            _this.reset();
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.render();
  }
};

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(535);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _echarts = __webpack_require__(577);

var _echarts2 = _interopRequireDefault(_echarts);

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

var _data = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = __webpack_require__(1);

exports.default = {
  data: function data() {
    return {
      projects: [{
        value: "",
        label: this.$t("stats.allProjects")
      }],
      periods: [{
        value: "24h",
        label: this.$t("stats.last24h")
      }, {
        value: "7d",
        label: this.$t("stats.last7d")
      }, {
        value: "30d",
        label: this.$t("stats.last30d")
      }],
      networks: [{
        value: "mainnet",
        label: "MAINNET"
      }, {
        value: "testnet",
        label: "TESTNET"
      }],
      uid: "",
      isAdmin: false,
      apikey: "",
      period: sessionStorage.getItem("statsPeriod") || "30d",
      network: sessionStorage.getItem("statsNetwork") || "mainnet",
      tzofs: new Date().getTimezoneOffset(),
      chartLine: null,
      chartPie: null,
      chartBar: null,
      chartHeatmap: null,
      topn: 10
    };
  },


  methods: {
    getProjects: function getProjects(cb) {
      var _this = this;

      _api2.default.getProjects({}).then(function (res) {
        if (res.data.CODE === _data.resCode.SUCCESS) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(res.data.DATA), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var project = _step.value;

              _this.projects.push({
                value: project["apikey"],
                label: project["name"]
              });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          cb();
        }
      }).catch(function (err) {
        console.error("get project error: " + err);
      });
    },
    completeTsData: function completeTsData(data, slice) {
      var result = [];
      for (var i = 0, ts = data[0]["k"], end = data[data.length - 1]["k"]; ts <= end; ts += slice) {
        if (ts === data[i]["k"]) {
          result.push({ k: ts, v: data[i]["v"] });
          i++;
        } else {
          result.push({ k: ts, v: 0 });
        }
      }
      return result;
    },
    get10Ceil: function get10Ceil(value) {
      if (value <= 10) {
        return 10;
      } else {
        var vs = value.toString();
        var pow = vs.length - 1;
        var q = parseInt(vs[0]),
            r = parseInt(vs.substring(1));
        if (r) q += 1;
        return q * Math.pow(10, pow);
      }
    },
    drawLineChart: function drawLineChart(time, value) {
      this.chartLine = _echarts2.default.init(document.getElementById("chartLine"), "light");
      this.chartLine.setOption({
        title: {
          text: this.$t("stats.totalMethodCalls")
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: time
        },
        yAxis: {
          type: "value"
        },
        series: [{
          symbol: "diamond",
          symbolSize: 15,
          data: value,
          type: "line"
        }]
      });
    },
    drawPieChart: function drawPieChart(name, value) {
      this.chartPie = _echarts2.default.init(document.getElementById("chartPie"), "light");
      this.chartPie.setOption({
        title: {
          text: this.$t("stats.projectMethodCalls")
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "right",
          data: name
        },
        series: [{
          name: "project",
          type: "pie",
          radius: "55%",
          center: ["50%", "60%"],
          data: value
        }]
      });
    },
    drawBarChart: function drawBarChart(name, value) {
      this.chartBar = _echarts2.default.init(document.getElementById("chartBar"));
      this.chartBar.setOption({
        title: {
          text: this.$t("stats.topnMethodCalls") + "TOP" + this.topn
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: [this.$t("stats.topnMethodCallsSummary")]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: "category",
          data: name
        },
        series: [{
          type: "bar",
          data: value,
          itemStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#83bff6" }, { offset: 0.5, color: "#188df0" }, { offset: 1, color: "#188df0" }])
            }
          }
        }]
      });
    },
    drawHeatmap: function drawHeatmap(today, mapData) {
      this.chartHeatmap = _echarts2.default.init(document.getElementById("chartHeatmap"), "light");
      var hours = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
      var daysArray = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
      var days = [];
      var data = [];
      var maxValue = 10;
      for (var i = 0; i < 7; i++) {
        var dayi = (today + i + 1) % 7;
        days.push(daysArray[dayi]);
        var datai = mapData[dayi];
        for (var j = 0; j < datai.length; j++) {
          datai[j][1] = i;
          if (datai[j][2] === 0) {
            datai[j][2] = "-";
          } else {
            maxValue = Math.max(maxValue, datai[j][2]);
          }
          data.push(datai[j]);
        }
      }
      this.chartHeatmap.setOption({
        title: {
          text: this.$t("stats.chartHeatmap")
        },
        tooltip: {
          position: "top"
        },
        animation: false,
        grid: {
          height: "50%",
          y: "10%"
        },
        xAxis: {
          type: "category",
          data: hours,
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: "category",
          data: days,
          splitArea: {
            show: true
          }
        },
        visualMap: {
          min: 0,
          max: this.get10Ceil(maxValue),
          calculable: true,
          orient: "horizontal",
          left: "center",
          bottom: "15%"
        },
        series: [{
          name: "CALLS",
          type: "heatmap",
          data: data
        }]
      });
    },
    drawCharts: function drawCharts() {
      var _this2 = this;

      var para = new _data.reqAnalyticTs(this.period, this.uid, this.apikey, this.network, this.tzofs);
      _api2.default.timeSeries(para).then(function (res) {
        var time = [];
        var value = [];
        if (res.data.CODE === _data.resCode.SUCCESS) {
          var slice = 60 * 60 * 1000;
          var formatHour = true;
          if (_this2.period !== "24h") {
            slice = slice * 24;
            formatHour = false;
          }
          var data = _this2.completeTsData(res.data.DATA, slice);
          var m = void 0,
              t = void 0;
          for (var i = 0; i < data.length; i++) {
            m = moment(data[i].k);
            if (formatHour) {
              t = m.format("h A");
            } else {
              t = m.format("M-D");
            }
            time.push(t);
            value.push(data[i].v);
          }
        }
        _this2.drawLineChart(time, value);
      }).catch(function (err) {
        console.error("get data error: " + err);
      });

      para = new _data.reqAnalyticTopn("project", 10, this.period, this.uid, null, this.network, this.tzofs);
      _api2.default.topn(para).then(function (res) {
        var name = [],
            value = [],
            showName = void 0;
        if (res.data.CODE === _data.resCode.SUCCESS) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(res.data.DATA), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var data = _step2.value;

              if (data["o"] && !_this2.uid) {
                showName = data["o"] + "' " + data["k"];
              } else {
                showName = data["k"];
              }
              name.push(showName);
              value.push({ value: data["v"], name: showName });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
        _this2.drawPieChart(name, value);
      }).catch(function (err) {
        console.error("get data error: " + err);
      });

      para = new _data.reqAnalyticTopn("method", 10, this.period, this.uid, this.apikey, this.network, this.tzofs);
      _api2.default.topn(para).then(function (res) {
        var name = [];
        var value = [];
        if (res.data.CODE === _data.resCode.SUCCESS) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)(res.data.DATA), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var data = _step3.value;

              name.unshift(data["k"]);
              value.unshift(data["v"]);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
        _this2.drawBarChart(name, value);
      }).catch(function (err) {
        console.error("get data error: " + err);
      });

      para = new _data.reqAnalyticTs("168h", this.uid, this.apikey, this.network, this.tzofs);
      _api2.default.timeSeries(para).then(function (res) {
        var mapData = [];
        if (res.data.CODE === _data.resCode.SUCCESS) {
          for (var i = 0; i < 7; i++) {
            mapData[i] = [];
          }
          var data = _this2.completeTsData(res.data.DATA, 60 * 60 * 1000);
          var m = void 0,
              day = void 0;
          for (var _i = 0; _i < data.length; _i++) {
            m = moment(data[_i].k);
            day = m.day();
            mapData[day].push(new Array(m.hour(), day, data[_i].v));
          }
        }
        _this2.drawHeatmap(moment().day(), mapData);
      }).catch(function (err) {
        console.error("get data error: " + err);
      });
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.isAdmin = sessionStorage.getItem("role") === "admin";
    if (this.isAdmin) {
      var username = this.$route.params.username;
      if (username) {
        this.uid = this.$route.params.uid;
        if (this.$route.params.apikey) {
          this.apikey = this.$route.params.apikey;
        }
        this.projects = [{
          value: "",
          label: username + "' " + this.$t("stats.allProjects")
        }];
        _api2.default.search({
          key: username
        }).then(function (res) {
          if (res.data.CODE === _data.resCode.SUCCESS) {
            res.data.DATA.projects.forEach(function (item) {
              _this3.projects.push({
                value: item["apikey"],
                label: username + "' " + item["name"]
              });
            });
          }
        }).catch(function () {});
      } else {
        this.drawCharts();
      }
    } else {
      this.getProjects(function () {
        if (_this3.projects.length === 1) {
          _this3.drawCharts();
        }
      });
    }
  },
  updated: function updated() {
    this.drawCharts();
    sessionStorage.setItem("statsPeriod", this.period);
    sessionStorage.setItem("statsNetwork", this.network);
  }
};

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(63);

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resCode = __webpack_require__(25).resCode;

var validator = __webpack_require__(123);

exports.default = {
  data: function data() {
    var _this = this;

    var validateEmail = function validateEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.emailRequried')));
      } else {
        if (validator.isEmail(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.emailFormat')));
        }
      }
    };
    var validateCode = function validateCode(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.verifyCodeRequried')));
      } else {
        if (validator.isLength(value, { min: 6, max: 6 }) && validator.isAlphanumeric(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.verifyCodeFormat')));
        }
      }
    };
    return {
      rstPwdForm: {
        email: "",
        code: ""
      },
      rstPwdRule: {
        email: [{ validator: validateEmail, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }]
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this2 = this;

      this.$refs.rstPwdForm.validate(function (valid) {
        if (valid) {
          var data = {
            email: _this2.rstPwdForm.email,
            code: _this2.rstPwdForm.code
          };
          (0, _request.resetPassword)(_this2, data);
        } else {
          return false;
        }
      });
    },
    getVerifyCode: function getVerifyCode() {
      var _this3 = this;

      this.$refs.rstPwdForm.validateField("email", function (err) {
        if (!err) {
          var data = {
            email: _this3.rstPwdForm.email,
            act: "reset password"
          };
          (0, _request.sendVerifyCode)(_this3, data);
        } else {
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _request = __webpack_require__(63);

var _Recaptcha = __webpack_require__(437);

var _Recaptcha2 = _interopRequireDefault(_Recaptcha);

var _utils = __webpack_require__(79);

var _data = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = __webpack_require__(123);
exports.default = {
  name: "login",
  components: {
    Recaptcha: _Recaptcha2.default
  },
  data: function data() {
    var _this = this;

    var validateUser = function validateUser(rule, value, cb) {
      if (value === "") {
        cb(new Error(_this.$t('login.emailNameRequired')));
      } else if (_data.pattern.username.test(value) || validator.isEmail(value)) {
        cb();
      } else {
        cb(new Error(_this.$t('login.emailNameFormat')));
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.passwordRequried')));
      } else {
        if (_data.pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.passwordFormat')));
        }
      }
    };
    return {
      loginForm: {
        user: "",
        password: ""
      },
      loginRule: {
        user: [{ validator: validateUser, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this2 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          if ((0, _utils.getCookie)("test_token")) {
            _this2.submit("");
          } else {
            _this2.$refs.recaptcha.execute();
          }
        } else {
          return false;
        }
      });
    },
    submit: function submit(token) {
      var data = { password: this.loginForm.password, recaptcha_token: token };
      if (validator.isEmail(this.loginForm.user)) {
        data.email = this.loginForm.user;
      } else {
        data.username = this.loginForm.user;
      }
      (0, _request.doLogin)(this, data);
    }
  }
};

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(436);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(182);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    iHeader: _Header2.default,
    iFooter: _Footer2.default
  }
};

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _data = __webpack_require__(25);

var _request = __webpack_require__(63);

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

var _Recaptcha = __webpack_require__(437);

var _Recaptcha2 = _interopRequireDefault(_Recaptcha);

var _utils = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = __webpack_require__(123);

exports.default = {
  components: {
    Recaptcha: _Recaptcha2.default
  },
  data: function data() {
    var _this = this;

    var validateUser = function validateUser(rule, value, cb) {
      if (value === "") {
        cb(new Error(_this.$t('common.usernameRequried')));
      } else if (!_data.pattern.username.test(value)) {
        cb(new Error(_this.$t('common.usernameFormat')));
      } else {
        _api2.default.checkUserExist({ username: value }).then(function (res) {
          if (res.data.CODE !== _data.resCode.USER_NOT_FOUND) {
            cb(new Error(_this.$t('signup.usernameUsed')));
          } else {
            cb();
          }
        }).catch(function () {
          cb();
        });
      }
    };
    var validateEmail = function validateEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.emailRequried')));
      } else {
        if (validator.isEmail(value)) {
          _api2.default.checkUserExist({ email: value }).then(function (res) {
            if (res.data.CODE !== _data.resCode.USER_NOT_FOUND) {
              callback(new Error(_this.$t('signup.emailUsed')));
            } else {
              callback();
            }
          }).catch(function () {
            callback();
          });
        } else {
          callback(new Error(_this.$t('common.emailFormat')));
        }
      }
    };
    var validateCode = function validateCode(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.verifyCodeRequried')));
      } else {
        if (validator.isLength(value, { min: 6, max: 6 }) && validator.isAlphanumeric(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.verifyCodeFormat')));
        }
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('common.passwordRequried')));
      } else {
        if (_data.pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('common.passwordFormat')));
        }
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error(_this.$t('signup.confirmPwdRequried')));
      } else if (value !== _this.regForm.pass) {
        callback(new Error(_this.$t('signup.confirmPwdMismatch')));
      } else {
        callback();
      }
    };
    return {
      regForm: {
        username: "",
        email: "",
        code: "",
        pass: "",
        checkPass: ""
      },
      regRule: {
        username: [{ validator: validateUser, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      var _this2 = this;

      this.$refs.regForm.validate(function (valid) {
        if (valid) {
          if ((0, _utils.getCookie)("test_token")) {
            _this2.submit("");
          } else {
            _this2.$refs.recaptcha.execute();
          }
        } else {
          return false;
        }
      });
    },
    getVerifyCode: function getVerifyCode() {
      var _this3 = this;

      this.$refs.regForm.validateField("email", function (err) {
        if (!err) {
          var data = {
            email: _this3.regForm.email,
            act: "register"
          };
          (0, _request.sendVerifyCode)(_this3, data);
        } else {
          return false;
        }
      });
    },
    submit: function submit(token) {
      var data = {
        username: this.regForm.username,
        password: this.regForm.pass,
        email: this.regForm.email,
        code: this.regForm.code,
        recaptcha_token: token
      };
      (0, _request.doRegister)(this, data);
    }
  }
};

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(436);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(182);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    iHeader: _Header2.default,
    iFooter: _Footer2.default
  }
};

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(201);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ROOT = _config2.default.API_ROOT;

exports.default = {
  register: API_ROOT + 'account/register',
  getVerifyCode: API_ROOT + 'account/getVerifyCode',
  deregister: API_ROOT + 'account/deregister',
  login: API_ROOT + 'account/login',
  identify: API_ROOT + 'account/identify',
  getUser: API_ROOT + 'account/getUser',
  changePassword: API_ROOT + 'account/password/change',
  resetPassword: API_ROOT + 'account/password/reset',
  changeEmail: API_ROOT + 'account/email/change',
  logout: API_ROOT + 'account/logout',
  checkUserExist: API_ROOT + 'account/checkExist',

  createProject: API_ROOT + 'project/create',
  modifyProject: API_ROOT + 'project/modify',
  deleteProject: API_ROOT + 'project/delete',
  getProjects: API_ROOT + 'projects',
  getEndpoints: API_ROOT + 'project/endpoints',
  checkProjectExist: API_ROOT + 'project/checkExist',

  timeSeries: API_ROOT + 'analytic/timeseries',
  topn: API_ROOT + 'analytic/topn',

  getTotalCount: API_ROOT + 'management/totalCount',
  getUsers: API_ROOT + 'management/users',
  search: API_ROOT + 'management/search',
  setUser: API_ROOT + 'management/setUser',
  setProject: API_ROOT + 'management/setProject'
};

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(466);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(24);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(471);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(467);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(468);

var _vueRouter = __webpack_require__(472);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(465);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(194);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(464);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(469);

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

var _axios = __webpack_require__(193);

var _axios2 = _interopRequireDefault(_axios);

var _vueI18n = __webpack_require__(470);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _locale = __webpack_require__(99);

var _locale2 = _interopRequireDefault(_locale);

var _clipboard = __webpack_require__(133);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resCode = __webpack_require__(25).resCode;

_vue2.default.prototype.Clipboard = _clipboard2.default;

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueI18n2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (sessionStorage.getItem("login") === null) {
    _api2.default.identify({}).then(function (res) {
      if (res.data.CODE === resCode.SUCCESS) {
        sessionStorage.setItem("login", "true");
        sessionStorage.setItem("role", res.data.DATA.role);
        navigate(to, from, next, true);
      } else {
        sessionStorage.setItem("login", "false");
        sessionStorage.removeItem("role");
        navigate(to, from, next, false);
      }
    }).catch(function (err) {
      sessionStorage.removeItem("login");
      sessionStorage.removeItem("role");
      navigate(to, from, next, false);
    });
  } else {
    navigate(to, from, next, sessionStorage.getItem("login") === "true");
  }
});

function navigate(to, from, next, authorized) {
  if (authorized) {
    if (to.name === "login" || to.name === "register") {
      if (sessionStorage.getItem("role") === "admin") {
        next({ name: "Users" });
      } else {
        next({ name: "Project Management" });
      }
    } else {
      next();
    }
  } else {
    if (to.requireAuth) {
      next({ name: "login" });
    } else {
      next();
    }
  }
}

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        sessionStorage.setItem("login", "false");
        sessionStorage.removeItem("role");
        router.replace({
          name: 'login',
          query: { redirect: router.currentRoute.fullPath }
        });
    }
  }
  return _promise2.default.reject(error.response.data);
});

var i18n = new _vueI18n2.default({
  locale: localStorage.getItem('locale') || 'en_US',
  messages: {
    'zh_CN': __webpack_require__(463),
    'en_US': __webpack_require__(462)
  }
});
_locale2.default.i18n(function (key, value) {
  return i18n.t(key, value);
});

new _vue2.default({
  router: router,
  i18n: i18n,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount("#app");

exports.router = router;

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doLogout = exports.doLogin = exports.showMsg = exports.resetPassword = exports.sendVerifyCode = exports.changeEmail = exports.changePassword = exports.doRegister = undefined;

var _api = __webpack_require__(32);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resCode = __webpack_require__(25).resCode;

var doRegister = exports.doRegister = function doRegister(that, data) {
  _api2.default.register(data).then(function (res) {
    var code = res.data.CODE;
    if (code === resCode.SUCCESS) {
      showMsg(that, true, that.$t('signup.registerSuccess'), "success");
      that.$router.push({ path: "/login" });
    } else if (code === resCode.VERIFY_CODE_MISMATCH) {
      showMsg(that, true, that.$t('common.veriryCodeMismatch'), "error");
    } else if (code === resCode.EMAIL_ALREADY_EXIST) {
      showMsg(that, true, that.$t('signup.emailUsed'), "error");
    } else if (code === resCode.USERNAME_ALREADY_EXIST) {
      showMsg(that, true, that.$t('signup.usernameUsed'), "error");
    } else {
      showMsg(that, true, that.$t('common.tyrLater'), "error");
    }
  }).catch(function (err) {
    console.log(err);
  });
};

var changePassword = exports.changePassword = function changePassword(that, data) {
  _api2.default.changePassword(data).then(function (res) {
    var code = res.data.CODE;
    if (code === resCode.SUCCESS) {
      showMsg(that, true, that.$t('changePwd.changeSuccess'), "success");
    } else if (code === resCode.USER_PASSWORD_MISMATCH) {
      showMsg(that, true, that.$t('changePwd.oldPwdIncorrect'), "error");
    }
  }).catch(function (err) {
    console.log(err);
  });
};

var changeEmail = exports.changeEmail = function changeEmail(that, data) {
  _api2.default.changeEmail(data).then(function (res) {
    var code = res.data.CODE;
    if (code === resCode.SUCCESS) {
      showMsg(that, true, that.$t('changeEmail.changeSuccess'), "success");
    } else if (code === resCode.VERIFY_CODE_MISMATCH) {
      showMsg(that, true, that.$t('common.veriryCodeMismatch'), "error");
    } else if (code === resCode.EMAIL_ALREADY_EXIST) {
      showMsg(that, true, that.$t('signup.emailUsed'), "error");
    } else if (code === resCode.USER_PASSWORD_MISMATCH) {
      showMsg(that, true, that.$t('changeEmail.pwdIncorrect'), "error");
    }
  }).catch(function (err) {
    console.log(err);
  });
};

var sendVerifyCode = exports.sendVerifyCode = function sendVerifyCode(that, data) {
  _api2.default.getVerifyCode(data).then(function (res) {
    var code = res.data.CODE;
    if (code === resCode.SUCCESS) {
      showMsg(that, true, that.$t('common.sendCodeSuccess'), "success");
    } else if (code === resCode.VERIFY_CODE_SENT) {
      showMsg(that, true, that.$t('common.codeSent'), "info");
    } else if (code === resCode.SEND_VERIFY_CODE_FAIL) {
      showMsg(that, true, that.$t('common.sendCodeFail'), "error");
    } else if (code === resCode.USER_NOT_FOUND) {
      showMsg(that, true, that.$t('common.emailNotRegister'), "error");
    }
  }).catch(function (err) {
    console.log(err);
  });
};

var resetPassword = exports.resetPassword = function resetPassword(that, data) {
  _api2.default.resetPassword(data).then(function (res) {
    var code = res.data.CODE;
    if (code === resCode.SUCCESS) {
      showMsg(that, true, that.$t('resetPwd.mailReminder'), "info");
      that.$router.push({ path: "/login" });
    } else if (code === resCode.VERIFY_CODE_MISMATCH) {
      showMsg(that, true, that.$t('common.veriryCodeMismatch'), "error");
    } else if (code === resCode.USER_NOT_FOUND) {
      showMsg(that, true, that.$t('common.emailNotRegister'), "error");
    } else {
      showMsg(that, true, that.$t('common.tyrLater'), "error");
    }
  }).catch(function (err) {
    console.log(err);
  });
};

var showMsg = exports.showMsg = function showMsg(that, close, msg, type) {
  that.$message({
    showClose: close,
    message: msg,
    type: type
  });
};

var doLogin = exports.doLogin = function doLogin(that, data) {
  _api2.default.login(data).then(function (res) {
    if (res.data.CODE === resCode.SUCCESS) {
      sessionStorage.setItem("login", "true");
      sessionStorage.setItem("role", res.data.DATA.role);
      if (res.data.DATA.role === "admin") {
        that.$router.push({ name: "Users" });
      } else {
        that.$router.push({ name: "Project Management" });
      }
    } else if (res.data.CODE === resCode.USER_PASSWORD_MISMATCH) {
      showMsg(that, true, that.$t('login.incorrectPwd'), "error");
    } else if (res.data.CODE === resCode.ACCOUNT_ABNORMAL) {
      showMsg(that, true, that.$t('login.accountAbnormal'), "error");
    } else {
      showMsg(that, true, that.$t('common.tyrLater'), "error");
    }
  }).catch(function (err) {
    console.log(err);
  });
};

var doLogout = exports.doLogout = function doLogout(that, data) {
  _api2.default.logout(data).then(function (res) {
    sessionStorage.setItem("login", "false");
    sessionStorage.removeItem('role');
    that.$router.push("/login");
  }).catch(function (err) {
    console.log(err);
  });
};

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(1);

exports.formatTime = function (src, format) {
    var time = moment(src);
    if (time.isValid()) {
        return time.format(format);
    } else {
        return src;
    }
};

exports.formatIp = function (src) {
    if (src != null) {
        return src.replace("::ffff:", "");
    } else {
        return "";
    }
};

exports.getCookie = function (name) {
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
        var item = cookies[i].split("=");
        if (item[0] === name) {
            return item[1];
        }
    }
    return "";
};

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 857:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 859:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 288,
	"./af.js": 288,
	"./ar": 296,
	"./ar-dz": 289,
	"./ar-dz.js": 289,
	"./ar-kw": 290,
	"./ar-kw.js": 290,
	"./ar-ly": 291,
	"./ar-ly.js": 291,
	"./ar-ma": 292,
	"./ar-ma.js": 292,
	"./ar-ps": 293,
	"./ar-ps.js": 293,
	"./ar-sa": 294,
	"./ar-sa.js": 294,
	"./ar-tn": 295,
	"./ar-tn.js": 295,
	"./ar.js": 296,
	"./az": 297,
	"./az.js": 297,
	"./be": 298,
	"./be.js": 298,
	"./bg": 299,
	"./bg.js": 299,
	"./bm": 300,
	"./bm.js": 300,
	"./bn": 302,
	"./bn-bd": 301,
	"./bn-bd.js": 301,
	"./bn.js": 302,
	"./bo": 303,
	"./bo.js": 303,
	"./br": 304,
	"./br.js": 304,
	"./bs": 305,
	"./bs.js": 305,
	"./ca": 306,
	"./ca.js": 306,
	"./cs": 307,
	"./cs.js": 307,
	"./cv": 308,
	"./cv.js": 308,
	"./cy": 309,
	"./cy.js": 309,
	"./da": 310,
	"./da.js": 310,
	"./de": 313,
	"./de-at": 311,
	"./de-at.js": 311,
	"./de-ch": 312,
	"./de-ch.js": 312,
	"./de.js": 313,
	"./dv": 314,
	"./dv.js": 314,
	"./el": 315,
	"./el.js": 315,
	"./en-au": 316,
	"./en-au.js": 316,
	"./en-ca": 317,
	"./en-ca.js": 317,
	"./en-gb": 318,
	"./en-gb.js": 318,
	"./en-ie": 319,
	"./en-ie.js": 319,
	"./en-il": 320,
	"./en-il.js": 320,
	"./en-in": 321,
	"./en-in.js": 321,
	"./en-nz": 322,
	"./en-nz.js": 322,
	"./en-sg": 323,
	"./en-sg.js": 323,
	"./eo": 324,
	"./eo.js": 324,
	"./es": 328,
	"./es-do": 325,
	"./es-do.js": 325,
	"./es-mx": 326,
	"./es-mx.js": 326,
	"./es-us": 327,
	"./es-us.js": 327,
	"./es.js": 328,
	"./et": 329,
	"./et.js": 329,
	"./eu": 330,
	"./eu.js": 330,
	"./fa": 331,
	"./fa.js": 331,
	"./fi": 332,
	"./fi.js": 332,
	"./fil": 333,
	"./fil.js": 333,
	"./fo": 334,
	"./fo.js": 334,
	"./fr": 337,
	"./fr-ca": 335,
	"./fr-ca.js": 335,
	"./fr-ch": 336,
	"./fr-ch.js": 336,
	"./fr.js": 337,
	"./fy": 338,
	"./fy.js": 338,
	"./ga": 339,
	"./ga.js": 339,
	"./gd": 340,
	"./gd.js": 340,
	"./gl": 341,
	"./gl.js": 341,
	"./gom-deva": 342,
	"./gom-deva.js": 342,
	"./gom-latn": 343,
	"./gom-latn.js": 343,
	"./gu": 344,
	"./gu.js": 344,
	"./he": 345,
	"./he.js": 345,
	"./hi": 346,
	"./hi.js": 346,
	"./hr": 347,
	"./hr.js": 347,
	"./hu": 348,
	"./hu.js": 348,
	"./hy-am": 349,
	"./hy-am.js": 349,
	"./id": 350,
	"./id.js": 350,
	"./is": 351,
	"./is.js": 351,
	"./it": 353,
	"./it-ch": 352,
	"./it-ch.js": 352,
	"./it.js": 353,
	"./ja": 354,
	"./ja.js": 354,
	"./jv": 355,
	"./jv.js": 355,
	"./ka": 356,
	"./ka.js": 356,
	"./kk": 357,
	"./kk.js": 357,
	"./km": 358,
	"./km.js": 358,
	"./kn": 359,
	"./kn.js": 359,
	"./ko": 360,
	"./ko.js": 360,
	"./ku": 362,
	"./ku-kmr": 361,
	"./ku-kmr.js": 361,
	"./ku.js": 362,
	"./ky": 363,
	"./ky.js": 363,
	"./lb": 364,
	"./lb.js": 364,
	"./lo": 365,
	"./lo.js": 365,
	"./lt": 366,
	"./lt.js": 366,
	"./lv": 367,
	"./lv.js": 367,
	"./me": 368,
	"./me.js": 368,
	"./mi": 369,
	"./mi.js": 369,
	"./mk": 370,
	"./mk.js": 370,
	"./ml": 371,
	"./ml.js": 371,
	"./mn": 372,
	"./mn.js": 372,
	"./mr": 373,
	"./mr.js": 373,
	"./ms": 375,
	"./ms-my": 374,
	"./ms-my.js": 374,
	"./ms.js": 375,
	"./mt": 376,
	"./mt.js": 376,
	"./my": 377,
	"./my.js": 377,
	"./nb": 378,
	"./nb.js": 378,
	"./ne": 379,
	"./ne.js": 379,
	"./nl": 381,
	"./nl-be": 380,
	"./nl-be.js": 380,
	"./nl.js": 381,
	"./nn": 382,
	"./nn.js": 382,
	"./oc-lnc": 383,
	"./oc-lnc.js": 383,
	"./pa-in": 384,
	"./pa-in.js": 384,
	"./pl": 385,
	"./pl.js": 385,
	"./pt": 387,
	"./pt-br": 386,
	"./pt-br.js": 386,
	"./pt.js": 387,
	"./ro": 388,
	"./ro.js": 388,
	"./ru": 389,
	"./ru.js": 389,
	"./sd": 390,
	"./sd.js": 390,
	"./se": 391,
	"./se.js": 391,
	"./si": 392,
	"./si.js": 392,
	"./sk": 393,
	"./sk.js": 393,
	"./sl": 394,
	"./sl.js": 394,
	"./sq": 395,
	"./sq.js": 395,
	"./sr": 397,
	"./sr-cyrl": 396,
	"./sr-cyrl.js": 396,
	"./sr.js": 397,
	"./ss": 398,
	"./ss.js": 398,
	"./sv": 399,
	"./sv.js": 399,
	"./sw": 400,
	"./sw.js": 400,
	"./ta": 401,
	"./ta.js": 401,
	"./te": 402,
	"./te.js": 402,
	"./tet": 403,
	"./tet.js": 403,
	"./tg": 404,
	"./tg.js": 404,
	"./th": 405,
	"./th.js": 405,
	"./tk": 406,
	"./tk.js": 406,
	"./tl-ph": 407,
	"./tl-ph.js": 407,
	"./tlh": 408,
	"./tlh.js": 408,
	"./tr": 409,
	"./tr.js": 409,
	"./tzl": 410,
	"./tzl.js": 410,
	"./tzm": 412,
	"./tzm-latn": 411,
	"./tzm-latn.js": 411,
	"./tzm.js": 412,
	"./ug-cn": 413,
	"./ug-cn.js": 413,
	"./uk": 414,
	"./uk.js": 414,
	"./ur": 415,
	"./ur.js": 415,
	"./uz": 417,
	"./uz-latn": 416,
	"./uz-latn.js": 416,
	"./uz.js": 417,
	"./vi": 418,
	"./vi.js": 418,
	"./x-pseudo": 419,
	"./x-pseudo.js": 419,
	"./yo": 420,
	"./yo.js": 420,
	"./zh-cn": 421,
	"./zh-cn.js": 421,
	"./zh-hk": 422,
	"./zh-hk.js": 422,
	"./zh-mo": 423,
	"./zh-mo.js": 423,
	"./zh-tw": 424,
	"./zh-tw.js": 424
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 878;

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bit.d3d9ef8.png";

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eth.8599943.png";

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAWlBMVEX4+v0AAAD4+v34+v3+/v/////4+v3////+/v/4+v34+v3////+/v/////+/v/9/v7////////////////+///////////9/f78/f77/P7////+///9/v////8oykDcAAAAHXRSTlMaABICd6cGn38OCrRtx19J8ty+uZfu5EA0KNCUU5lMZ4oAAAFySURBVEjHpdfrcoQgDAXgs4kFsereb215/9fsjtuuBoQVc37zDSgzIcFmNmwcEYYQOcPzqzAnG0IQangRNqOU3uSxpHkeY5Y05pzGDd6mSWGHBXHzmLAoxDFmAko1hC3UGM9coCV2KIqb4gaFaUbMKA6/MJVj+scGK2L+MK3B9MQGWLk1go3bvU9m38qtH5iF9dlU8odD3rF/k624a2yoBFtxbjBK8Kc4N8x6bODm8eFkXzkd/DOdxA4kcX0alu0gsnv+rR+JKcQ92mGlrSexwy1fUYUYElfA7ehncgRCjBgPi6J8YynG7RDYFssxUE/pZYsijGv3st0dBVhuboEUpiTG9utBzxVSmHIY6Ov+jgx2MZZJYwezHhuwxG0Ot/6ISTgsBjaHrSwGcRnq07aPyxDLr/LdRyJdWADj0nvxyZyFJVXR1zw3qodO88SqHndNW6FpaDStlKqJ07SPmsZV0TJrmnXNmKAdUPSjkX4oU42Dv9b8NKk6hxzrAAAAAElFTkSuQmCC"

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAWlBMVEX4+v0AAAD4+v34+v34+v38/f7////////////6/P7////////////////////+///+///+/v/+/v/9/v78/f77/P76+/3////////////+/v/+/v/+/v/////wLudgAAAAHXRSTlMZAA4IEy/ateAk+vLDopmQiHFpTjcpH+XNp19/d3h2abwAAADYSURBVCjPhZNZDsMgDESnQKDZmn1tuf81m8ZAKCji/UTiaWwptvFwcCZwIBi/3pxm8GCB5gjgvmaIYJcWQIwg7WXjPFzfGH5q3HI4Kn1XHmF4V1Uz5cNMcZjOr4a+nT5Y5Cun7jC1K938AlOpT+qMqkOYtNayyzCSlWStBMbleC2VKk6tEPB+ao861K326RGyebag1n73zKu+XZJZLZ0tR6sZ3EDy1ub3ayjmp8450JMuOjjsSKbPqolq+B8JxbO+XqVULUlDYh0Sy5RYxcQiJ84geUSJE/wCtFEQw2znHjMAAAAASUVORK5CYII="

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAARVBMVEX4+v0AAAD4+v34+v3////4+v37/P75+/3////////9/v7////////////////////+/v/////+///+///9/v/8/f7///8T9l+/AAAAFnRSTlMaAA4I7RMkHvrzSue/utmoad+QjFI6o54PlQAAALBJREFUKM+Fk+kSwjAIhFdymKSXJ+//qNbRaZdW6f4L35CFAXBaFCRhVpKwxhYsIMkGB2wUGAt2khUn/FD6Yptr88G+e/8Zc+TS1zotrzcWpjor0vcwyVfVrr9hTQc756olG3eYsqN2tnhQz+1RNbb2pN5B0o8mju3x/Q/uh6JlGJoJeqVZ9xw1ni0UDwuChwNOHrYjyaqFsdiB5jGOjI/XwV8mfxX9RfbP4PiIDk7wBYrUBg5qQmIoAAAAAElFTkSuQmCC"

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAQlBMVEX4+v0AAAD4+v3////+/v/9/f7+/v/////////8/f7////////9/v/////+///+///////7/P7////9/f7+/v////9Zad0SAAAAFXRSTlMaABHeXzt2tqox8sxOwJSK6iihRIJYVZqAAAAB5klEQVRIx6WXW46AIAxFOyD4QvHF/rc6o5JIvcUh4X6Z4KGFllLoJyOlFF36+8j9QzJILylVCEcSeBlGtBCnMhRxhOlfAQxmS40TsuU0IVtOE7LlNOVY51u9DMOiW+9yNIms2XRIpDcj0iTEqO8CqOuFiBGyNoiySBM4zcwy4+A4vQ2PIauRmY6wAraAVhGmR234VEuPbli99+rY7WuS6XDze9fUBScxCpeuHBnD2G7zvLVj0A0RrfdYn5qm1PB0p0SciYh96LfjisEmRBj0wMEwGCNsJNZgtBkcSuAhhR+vmzh8MAiytnn8TuAZliwuehbh6R70OfiIMX9gnNnlYPfl2SJuF6TQQpKGMnj4gvccbL5gzUKBar7WPLIUQnXCoYbsXDNwHN7SOEMKTQyBOmFFuA9Rs8TOIapP4B+hfrXg+doF5heequa06k73Bm9YkHwMIw8GryT6qhT+3lRPUT6tqBoqCcvePW67FW8Qx2CovJpo4mub5FvjXXppuSdvrO15GcDsUlD0zflHD3kZNaQjwnXjzn9mZ/YV4cFww3jR7UsMCcCahU++YtcJYTwwKnO5k10Q1g0x8baC45rD2hIXNjTlUthKlbPVTVx9+1jfuJbTqqJZr3kmVD9Q6p9G9Y+yqufgL52lOFFHcohZAAAAAElFTkSuQmCC"

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAADCAMAAAAwYnbuAAAAkFBMVEUAAABXVEn//vv6+fb08+/t7Ojd29bT0c20sqypp6CenJWUkYrmxoDiw37dvnzXunnQtHeAfHXIrnTBqHF2dGuvmWqdi2NtamGUhF+BdVl5blVeW1JxaFFpYk9iXExcWEnl4+DJxsK+vLeKh4C4oG2mkmeKfFtlYlnk5N/Jx8K/vbeKh3+4oW6lkmeLfVxlY1nNcQpuAAAAAXRSTlMAQObYZgAAAE1JREFUCNdj4OHl4xcQElYRVRWTUJOUkpGVk2dkAAEmZhZWBTZ2RS0OTi5uZUERcXVpRhTVelhUayrBVOsjVOuI6mIxWwNoNli1NsRsAIwQCWidDcvSAAAAAElFTkSuQmCC"

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODg3NERBQjc2QUFCMTFFN0JEN0ZFRjBFMDdCRDUxRTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODg3NERBQjg2QUFCMTFFN0JEN0ZFRjBFMDdCRDUxRTMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4ODc0REFCNTZBQUIxMUU3QkQ3RkVGMEUwN0JENTFFMyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4ODc0REFCNjZBQUIxMUU3QkQ3RkVGMEUwN0JENTFFMyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmhQxGcAAAI8SURBVHjazFfPS9xAFJ55yRqXIlvXHxdhT4VePbSUFkGriKDQi2fBi+1Jr/0HivTca8+tVw+lUE+CLIh/QOmhl0JR8KCoXbK7yWb6pUwkbJN5kyWLPviY7OZlvrwf896LbHd7wkIk4GlUAFf/F4sCQiAAOhqK3ZAhJuCBBgk7iYCWRjQIcRWoFSDMeoErwC9CXNNWliEt/QL/ubJf6iWSCr1XnbOYtdQhOQa8lFLMxW5USjS7YXRQ1PI0cRzTcdOTIy6tgfAdLqf7bv2IIrUd9NR3hvwyiXlCTHozMpDOg/SzYdMeyBdB/pNJuPN4pVQccklJCg+kHxlrHCL5ntFJjue/C8nF1XXohWXCPUf8pyySTZKuRtxZnbBNYVj9yMJqLyE2lzcpVmyJobtsoebFyTUZ506+m+UM3HdS4Nz+6QTRY0anS7rgmyyYLFgwHAsdl1JdJiej5W5B4qpXoQ9cRIgpGG+wzA5QJtcrrnzCZZgyuHlz0AINT+0YbivSTTxPGgNwJoYsGXRC0pNDnhyhCWxgPS5AvIdntrE2DTpBfJxGs9pWWhCvp3Ddvs1RCkI1GynlM3oXpGekyNAGH4L0taW1FdeVb5EbDtMoOklytQzEr7CsZtzqZFYkIbbwTIPpy4pSPzKthtu+Yfmq29kN8Av4EvbUM7TBBVwfAmfANfAb+IT/T5lBsNggUILcDgLpAuKbXF7S0OfnDXvxTNQeAmm7f9LMKpkXJVve0nve74H+Tj9hhvrR9leAAQABd7uvp0kKqAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qqer.3348469.png";

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wci.421c62b.png";

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wci3.d50542b.png";

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wechatEn.cb8d65f.jpg";

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(868)

var Component = __webpack_require__(18)(
  /* script */
  null,
  /* template */
  __webpack_require__(984),
  /* scopeId */
  "data-v-5f53d734",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(861)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(977),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(869)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(985),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(856)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(973),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(859)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(975),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(870)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(871)
__webpack_require__(872)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  "data-v-7e51bb7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(857)
__webpack_require__(858)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(974),
  /* scopeId */
  "data-v-1eac87c3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(855)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(972),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(864)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(865)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(981),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(867)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(876)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(860)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(976),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(862)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(978),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 972:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-container"
  }, [_c('section', [_c('el-col', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("projectManage.title")))])]), _vm._v(" "), _c('div', {
    staticClass: "addNew"
  }, [_c('div', {
    staticClass: "newBtn",
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("projectManage.create")))])])]), _vm._v(" "), _c('div', {
    staticClass: "project-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.projects,
      "empty-text": _vm.$t('common.noData'),
      "highlight-current-row": "",
      "min-width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('projectManage.name'),
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "apikey",
      "label": _vm.$t('projectManage.apikey'),
      "min-width": "32%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.apikey))]), _vm._v(" "), _c('p', {
          staticClass: "keyP"
        }, [_vm._v(_vm._s(scope.row.apikey))])]), _vm._v(" "), _c('div', {
          staticClass: "tag",
          on: {
            "click": function($event) {
              return _vm.copy('apikey', scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secret",
      "label": _vm.$t('projectManage.secret'),
      "min-width": "32%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.secret))]), _vm._v(" "), _c('p', {
          staticClass: "keyP"
        }, [_vm._v(_vm._s(scope.row.secret))])]), _vm._v(" "), _c('div', {
          staticClass: "tag",
          on: {
            "click": function($event) {
              return _vm.copy('secret', scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('projectManage.operation'),
      "min-width": "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("projectManage.edit")))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("projectManage.delete")))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('projectManage.editWndTitle'),
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('projectManage.editWndName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.editSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('projectManage.createWndTitle'),
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('projectManage.createWndName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "EndpointBox"
  }, [_c('p', [_c('span', {
    staticClass: "EndpointTit"
  }, [_vm._v(_vm._s(_vm.$t("projectManage.endpoint")))]), _vm._v(" "), _c('el-select', {
    on: {
      "change": _vm.selectNetwork
    },
    model: {
      value: (_vm.network),
      callback: function($$v) {
        _vm.network = $$v
      },
      expression: "network"
    }
  }, _vm._l((_vm.networks), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "EndpointCon"
  }, [_vm._v(_vm._s(_vm.endpoint))])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-container"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("changePwd.title")))])])]), _vm._v(" "), _c('div', {
    staticClass: "cp-container"
  }, [_c('section', [_c('el-form', {
    ref: "chgPwdForm",
    attrs: {
      "model": _vm.chgPwdForm,
      "status-icon": "",
      "rules": _vm.chgPwdRule,
      "label-width": "170px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('changePwd.oldPassword'),
      "prop": "oldPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgPwdForm.oldPass),
      callback: function($$v) {
        _vm.$set(_vm.chgPwdForm, "oldPass", $$v)
      },
      expression: "chgPwdForm.oldPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('changePwd.newPassword'),
      "prop": "newPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgPwdForm.newPass),
      callback: function($$v) {
        _vm.$set(_vm.chgPwdForm, "newPass", $$v)
      },
      expression: "chgPwdForm.newPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('changePwd.retypePassword'),
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgPwdForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.chgPwdForm, "checkPass", $$v)
      },
      expression: "chgPwdForm.checkPass"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "cp-Btn",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "index-container"
  }, [_c('div', {
    staticClass: "ic-banner"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "ic-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "userBox"
  }, [_c('el-menu', {
    staticClass: "docMenu",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("index.documentation")))])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "../../static/apidoc/docs.html",
      "target": "_blank"
    }
  }, [_vm._v("API")])]), _vm._v(" "), _c('el-submenu', {
    staticClass: "subMenu",
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("SDK")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-js-sdk",
      "target": "_blank"
    }
  }, [_vm._v("JavaScript")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-java-sdk",
      "target": "_blank"
    }
  }, [_vm._v("Java")])])], 2)], 2)], 1), _vm._v(" "), _c('i', {
    staticClass: "line-w"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.login")))]), _vm._v(" "), _c('i', {
    staticClass: "line-w"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "register"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.signup")))]), _vm._v(" "), _c('i', {
    staticClass: "line-w"
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.langToggle
    }
  }, [_vm._v(_vm._s(_vm.$t("index.lang")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "icb-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("index.gatewayTitle")))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("index.gatewayInfo")))])]), _vm._v(" "), _c('router-link', {
    staticClass: "freeBtn",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.signup")))]), _vm._v(" "), _vm._m(2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ic-article"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("index.benefitTitle")))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "why-container"
  }, [_c('dl', [_vm._m(4), _vm._v(" "), _c('dd', [_c('h5', [_vm._v(_vm._s(_vm.$t("index.benefit1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("index.benefit1info")))])])]), _vm._v(" "), _c('dl', [_vm._m(5), _vm._v(" "), _c('dd', [_c('h5', [_vm._v(_vm._s(_vm.$t("index.benefit2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("index.benefit2info")))])])]), _vm._v(" "), _c('dl', [_vm._m(6), _vm._v(" "), _c('dd', [_c('h5', [_vm._v(_vm._s(_vm.$t("index.benefit3")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("index.benefit3info")))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "he-container"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("index.summary")))]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('iFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(76),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": __webpack_require__(887),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ico"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://t.me/WanchainANN"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(890),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://twitter.com/wanchain_org"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(884),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/wanchainfoundation/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(885),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(886),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "mailto:techsupport@wanchain.org"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(883),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://weibo.com/wanchain"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(894),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "webcat"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(895),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "weiCode",
    attrs: {
      "src": __webpack_require__(896),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qq"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(888),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "qqCode",
    attrs: {
      "src": __webpack_require__(889),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "line-p"
  }, [_c('i', {
    staticClass: "com-line2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('img', {
    attrs: {
      "src": __webpack_require__(891),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('img', {
    attrs: {
      "src": __webpack_require__(892),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('img', {
    attrs: {
      "src": __webpack_require__(893),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "line-p"
  }, [_c('i', {
    staticClass: "com-line2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('img', {
    staticClass: "bit",
    attrs: {
      "src": __webpack_require__(881),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "eth",
    attrs: {
      "src": __webpack_require__(882),
      "alt": ""
    }
  })])])
}]}

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Aprojects-container"
  }, [_c('section', [_c('el-col', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("admin.projects")))])])]), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "60px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('admin.searchProject'),
      "icon": "search",
      "on-icon-click": _vm.searchProject
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchProject.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "seaBox"
  }, [(_vm.user.role) ? _c('ul', {
    staticClass: "seaBUl"
  }, [_c('li', [_c('span', {
    staticClass: "seaUTit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.username")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "seaUTex"
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "seaUTit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.email")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "seaUTex"
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "seaUTit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.role")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "seaUTex"
  }, [_vm._v(_vm._s(_vm.user.role))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "seaUTit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.status")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "seaUTex"
  }, [_vm._v(_vm._s(_vm.user.status))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.projects,
      "empty-text": _vm.$t('common.noData'),
      "highlight-current-row": "",
      "min-width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('projectManage.name'),
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "apikey",
      "label": _vm.$t('projectManage.apikey'),
      "min-width": "25%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.apikey))]), _vm._v(" "), _c('p', {
          staticClass: "keyP"
        }, [_vm._v(_vm._s(scope.row.apikey))])]), _vm._v(" "), _c('div', {
          staticClass: "tag",
          on: {
            "click": function($event) {
              return _vm.copy('apikey', scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secret",
      "label": _vm.$t('projectManage.secret'),
      "min-width": "25%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.secret))]), _vm._v(" "), _c('p', {
          staticClass: "keyP"
        }, [_vm._v(_vm._s(scope.row.secret))])]), _vm._v(" "), _c('div', {
          staticClass: "tag",
          on: {
            "click": function($event) {
              return _vm.copy('secret', scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": _vm.$t('projectManage.createDate'),
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('common.operation'),
      "min-width": "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "on-value": "normal",
            "off-value": "disabled",
            "on-color": "#13ce66",
            "off-color": "#cdcdcd"
          },
          on: {
            "change": function($event) {
              return _vm.setProject(scope.row)
            }
          },
          model: {
            value: (scope.row.status),
            callback: function($$v) {
              _vm.$set(scope.row, "status", $$v)
            },
            expression: "scope.row.status"
          }
        }), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin": "0 0 0 20px"
          },
          attrs: {
            "type": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.projectStats(scope.row.apikey)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("stats.title")))])]
      }
    }])
  })], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-bg"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "user-logo",
    attrs: {
      "src": __webpack_require__(76)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("signup.title")))]), _vm._v(" "), _c('div', {
    staticClass: "user-form"
  }, [_c('el-form', {
    ref: "regForm",
    attrs: {
      "model": _vm.regForm,
      "status-icon": "",
      "rules": _vm.regRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": _vm.$t('signup.username')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "username",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.regForm.username),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "username", $$v)
      },
      expression: "regForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('signup.email')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.regForm.email),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "email", $$v)
      },
      expression: "regForm.email"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "title": _vm.$t('common.sendCodeTip')
    },
    on: {
      "click": _vm.getVerifyCode
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t("common.sendCode")))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "code",
      "label": _vm.$t('common.verifyCode')
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.regForm.code),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "code", $$v)
      },
      expression: "regForm.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pass",
      "label": _vm.$t('signup.password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.regForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "pass", $$v)
      },
      expression: "regForm.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass",
      "label": _vm.$t('signup.confirm')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.regForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.regForm, "checkPass", $$v)
      },
      expression: "regForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("signup.signup")))]), _vm._v(" "), _c('recaptcha', {
    ref: "recaptcha",
    on: {
      "verify": _vm.submit
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "serviceBox"
  }, [_vm._v(_vm._s(_vm.$t("signup.privacyBegin")) + "\n        "), _c('router-link', {
    staticClass: "go-regi",
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v(_vm._s(_vm.$t("signup.service")))]), _vm._v(_vm._s(_vm.$t("signup.privacyAnd")) + "\n        "), _c('router-link', {
    staticClass: "go-regi",
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v(_vm._s(_vm.$t("signup.privacy")))]), _vm._v(_vm._s(_vm.$t("signup.privacyEnd")) + "\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "signUp"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("signup.haveAccount")) + "\n        "), _c('router-link', {
    staticClass: "go-regi",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("signup.login")))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 977:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-management"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("accountInfo.title")))])])]), _vm._v(" "), _c('div', {
    staticClass: "com-container"
  }, [_c('table', {
    staticClass: "act-ifmTable"
  }, [_c('tr', [_c('td', {
    staticClass: "tab-tit",
    attrs: {
      "width": "210"
    }
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.username")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.email")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.registerDate")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.created))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.status")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.status))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.lastDate")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.lastIp")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ip))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 978:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('iHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('iFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("IMPORTANT NOTICE: THIS AGREEMENT IS SUBJECT TO BINDING ARBITRATION\n        AND A WAIVER OF CLASS ACTION RIGHTS AS DETAILED IN SECTION 14. PLEASE\n        READ THE AGREEMENT CAREFULLY.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("1. ACCEPTANCE OF TERMS")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Wanchain Foundation")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("'s ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" (“")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("”) serves as a gateway to the decentralized internet by providing\n        scalable access to the ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Wanchain")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" blockchain. ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        hosts a website that serves as a registration portal, product\n        offering, and an overview of the health of ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("i")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Wan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        services through our website located at: ")]), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("https://")]), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("i")]), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("w")]), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("an")]), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(".")]), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("wanchain.org")]), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("/ ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("(the \"Site\") which includes text, images, audio, code and other\n        materials or ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("third party")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        information. The Site and any other features, tools, materials, or\n        services offered from time to time by ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(", including our network infrastructure, is referred to here as the\n        “Service.” Please read these Terms of Use (the “Terms” or “Terms of\n        Use”) carefully before using the Service. By using or otherwise\n        accessing the Services, or clicking to accept or agree to these Terms\n        where that option is made available, you (1) accept and agree to these\n        Terms (2) consent to the collection, use, disclosure and other\n        handling of information as described in our Privacy Policy and (3) any\n        additional terms, rules and conditions of participation issued by ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        from time to time. If you do not agree to the Terms, then you may not\n        access or use the Services.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("2. MODIFICATION OF TERMS OF USE")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Except for Section 14, providing for binding arbitration and waiver\n        of class action rights, ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        reserves the right, at its sole discretion, to modify or replace the\n        Terms of Use at any time. The most current version of these Terms will\n        be posted on our Site. You shall be responsible for reviewing and\n        becoming familiar with any such modifications. Use of the Services by\n        you after any modification to the Terms constitutes your acceptance of\n        the Terms of Use as modified.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("3. ELIGIBILITY")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("You represent and warrant that you: (a) are of legal age to form a\n        binding contract; (b) have not previously been suspended or removed\n        from using our Services; and (c) have full power and authority to\n        enter into this agreement and in doing so will not violate any other\n        agreement to which you are a party. If you are registering to use the\n        Services on behalf of a legal entity, you further represent and\n        warrant that (")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("i")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(") such legal entity is duly organized and validly existing under the\n        applicable laws of the jurisdiction of its organization, and (ii) you\n        are duly authorized by such legal entity to act on its behalf.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("4. ACCOUNT REGISTRATION")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Usage or access to our services may require an account consisting of\n        a User ID and/or a Password (\"Account\"). When you create an Account,\n        you agree to: (a) create a strong password that you do not use for any\n        other website or online service; (b) provide accurate and truthful\n        information; (c) maintain and promptly update your Account\n        information; (d) maintain the security of your Account by protecting\n        your Account password and restricting access to your computer and your\n        Account; (e) promptly notify us if you discover or otherwise suspect\n        any security breaches related to your Account; and (f) take\n        responsibility for all activities that occur under your Account and\n        accept all risks of any authorized or unauthorized access to your\n        Account, to the maximum extent permitted by law. When you create an\n        Account, we assign you an account identifier that you must retain to\n        access your Account.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("5. UNAUTHORIZED USE OR ACCESS")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Unless otherwise expressly authorized in these Terms of Use or on the\n        Website, you may not take any action to interfere with the Website or\n        any other user’s use of the Website or decompile, reverse engineer or\n        disassemble any Content or other products or processes accessible\n        through the Website, nor insert any code or product or manipulate the\n        Content in any way that affects any user’s experience. While using the\n        Website you are required ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("to comply with all applicable statutes, orders, regulations, rules,\n        and other laws. In addition, we expect users of the Website to respect\n        the rights and dignity of others. Your use of the Website is\n        conditioned on your compliance with the rules of conduct set forth in\n        this section.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("You agree that you will neither use the Site in a manner, nor share\n        any Content, that: (a) is false or misleading; (b) is defamatory,\n        derogatory, degrading or harassing of another or constitutes a\n        personal attack; (c) invades another's privacy or includes, copies or\n        transmits another's confidential, sensitive or personal information;\n        (d) promotes bigotry, racism, hatred or harm against any group or\n        individual; (e) is obscene or not in good taste; (f) violates or\n        infringes or promotes the violation or infringement of another's\n        rights, including intellectual property rights; (g) you do not have\n        the right and authority to share and grant the necessary rights and\n        licenses for; (h) violates or promotes the violation of any applicable\n        laws or regulations; (")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("i")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(") contains a solicitation of funds, goods or services, or promotes or\n        advertises goods or services; or (j) contains any viruses, Trojan\n        horses, or other components designed to limit or harm the\n        functionality of a computer.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Additionally, you acknowledge and agree that you (and not ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Wanchain Fou")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("n")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("dation")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(") are responsible for obtaining and maintaining all\n        telecommunications, broadband, and computer hardware, equipment, and\n        services needed to access and use the Website, and paying all charges\n        related thereto.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("6. REPRESENTATIONS, WARRANTIES AND RISKS")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("6.1. Warranty disclaimer")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("You expressly understand and agree that your use of the Service is at\n        your sole risk. The Service is provided on an \"AS IS\" and \"as\n        available\" basis, without warranties of any kind, either express or\n        implied, including, without limitation, implied warranties of\n        merchantability, fitness for a particular purpose or non-infringement.\n        You release ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        from all liability for content you acquired or failed to acquire\n        through the Service.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("6.2 Sophistication and Risk of Cryptographic Systems")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("By utilizing the Service or platform in any way, you represent that\n        you understand the inherent risks associated with cryptographic\n        systems; and warrant that you have an understanding of the usage and\n        intricacies of public/private key cryptography, native cryptographic\n        tokens, like")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" Wan (WAN),")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        Ether (ETH) and Bitcoin (BTC), smart ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("contract based")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" tokens such as")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        WRC20 and ERC20 tokens")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(", and blockchain-based software systems.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("6.3 Platform Security")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        is an early stage platform. You acknowledge that ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Wanchain")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        applications are code subject to flaws and acknowledge that you are\n        solely responsible for evaluating any available code provided by the\n        Services. You further expressly acknowledge and represent that ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Wanchain")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        applications can be written maliciously or negligently, that ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        cannot be held liable for your interaction with such applications and\n        that such applications may cause loss of property or identity. These\n        warnings and others later provided by ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        in no way evidence or represent an on-going duty to alert you to all\n        of the potential risks of utilizing the Service or Content.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("7. INDEMNITY")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("You agree, to the fullest extent permitted by applicable law, to\n        release and to indemnify, defend and hold harmless ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        and its parents, subsidiaries, affiliates and agencies, as well as the\n        officers, directors, employees, shareholders and representatives of\n        any of the foregoing entities, from and against any and all losses,\n        liabilities, expenses, damages, costs (including attorneys’ fees and\n        court costs) claims or actions of any kind whatsoever arising or\n        resulting from your use of the Service, your violation of these Terms\n        of Use, and any of your acts or ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("omissions that implicate publicity rights, defamation or invasion of\n        privacy. ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        reserves the right, at its own expense, to assume exclusive defense\n        and control of any matter otherwise subject to indemnification by you\n        and, in such case, you agree to cooperate with ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        in the defense of such matter.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("8. LIMITATION ON LIABILITY")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("YOU ACKNOWLEDGE AND AGREE THAT YOU ASSUME FULL RESPONSIBILITY FOR\n        YOUR USE OF THE SITES AND SERVICE. YOU ACKNOWLEDGE AND AGREE THAT ANY\n        INFORMATION YOU SEND OR RECEIVE DURING YOUR USE OF THE SITES AND\n        SERVICE MAY NOT BE SECURE AND MAY BE INTERCEPTED OR LATER ACQUIRED BY\n        UNAUTHORIZED PARTIES. YOU ACKNOWLEDGE AND AGREE THAT YOUR USE OF THE\n        SITES AND SERVICE IS AT YOUR OWN RISK. RECOGNIZING SUCH, YOU\n        UNDERSTAND AND AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY\n        APPLICABLE LAW, NEITHER ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("IWAN")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        NOR ITS SUPPLIERS OR LICENSORS WILL BE LIABLE TO YOU FOR ANY DIRECT,\n        INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY OR\n        OTHER DAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION DAMAGES FOR\n        LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER TANGIBLE OR INTANGIBLE\n        LOSSES OR ANY OTHER DAMAGES BASED ON CONTRACT, TORT (INCLUDING, IN\n        JURISDICTIONS WHERE PERMITTED, NEGLIGENCE AND GROSS NEGLIGENCE),\n        STRICT LIABILITY OR ANY OTHER THEORY (EVEN IF ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("IWAN")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        HAD BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM\n        THE SITE OR SERVICE; THE USE OR THE INABILITY TO USE THE SITES OR\n        SERVICE; UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR\n        DATA; STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON THE SITES OR\n        SERVICE; ANY ACTIONS WE TAKE OR FAIL TO TAKE AS A RESULT OF\n        COMMUNICATIONS YOU SEND TO US; HUMAN ERRORS; TECHNICAL MALFUNCTIONS;\n        FAILURES, INCLUDING PUBLIC UTILITY OR TELEPHONE OUTAGES; OMISSIONS,\n        INTERRUPTIONS, LATENCY, DELETIONS OR DEFECTS OF ANY DEVICE OR NETWORK,\n        PROVIDERS, OR SOFTWARE (INCLUDING, BUT NOT LIMITED TO, THOSE THAT DO\n        NOT PERMIT PARTICIPATION IN THE SERVICE); ANY INJURY OR DAMAGE TO\n        COMPUTER EQUIPMENT; INABILITY TO FULLY ACCESS THE SITES OR SERVICE OR\n        ANY OTHER WEBSITE; THEFT, TAMPERING, DESTRUCTION, OR UNAUTHORIZED\n        ACCESS TO, IMAGES OR OTHER CONTENT OF ANY KIND; DATA THAT IS PROCESSED\n        LATE OR INCORRECTLY OR IS INCOMPLETE OR LOST; TYPOGRAPHICAL, PRINTING\n        OR OTHER ERRORS, OR ANY COMBINATION THEREOF; OR ANY OTHER MATTER\n        RELATING TO THE SITES OR SERVICE. SOME JURISDICTIONS DO NOT ALLOW THE\n        EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF\n        LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME\n        OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("9. LICENSE")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Subject to your compliance with these Terms of Use, ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        grants you a limited, non-exclusive, non-transferable,\n        non-sublicensable license to access and make personal and\n        non-commercial use of the Service. This license does not include any\n        resale or commercial use of the Service or any derivative use of the\n        Service. All rights not expressly granted to you in these Terms of Use\n        are reserved and retained by ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        or its licensors. The ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        Service may not be reproduced, duplicated, copied, sold, resold,\n        visited, or otherwise exploited for any commercial purpose without\n        express written consent of ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(". You may not frame or utilize framing techniques to enclose any\n        trademark, logo, or other proprietary information (including images,\n        text, page layout, or form) of ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        without express written consent. You may not misuse the Services. You\n        may use the Services only as permitted by law. The licenses granted by ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        terminate if you do not comply with these Terms of Use.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("10. DISCONTINUANCE OF SERVICES")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("We may, in our sole discretion and without liability to you, with or\n        without prior notice and at any time, modify or discontinue,\n        temporarily or permanently, any portion of our Services.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("11. TERMINATION AND SUSPENSION")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        may terminate or suspend all or part of the Service without prior\n        notice or liability if you breach any of the terms or conditions of\n        the Terms. The following provisions of the Terms survive any\n        termination of these Terms: INDEMNITY; WARRANTY DISCLAIMERS;\n        LIMITATION ON LIABILITY; OUR PROPRIETARY RIGHTS; TERMINATION; NO ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("THIRD PARTY")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        BENEFICIARIES; BINDING ARBITRATION AND CLASS ACTION WAIVER; GENERAL\n        INFORMATION.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("12. NO THIRD PARTY BENEFICIARIES")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("You agree that, except as otherwise expressly provided in these\n        Terms, there shall be no ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("third party")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        beneficiaries to the Terms.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("13. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT\n        INFRINGEMENT")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("If you believe that your copyright or the copyright of a person on\n        whose behalf you are authorized to act has been infringed, please\n        provide ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("'s")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        Copyright Agent a written notice containing the following\n        information:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("an electronic or physical signature of the person authorized to act\n        on behalf of the owner of the copyright or other intellectual property\n        interest;")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("a description of the copyrighted work or other intellectual property\n        that you claim has been infringed;")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("a description of where the material that you claim is infringing is\n        located on the Service;")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("your address, telephone number, and email address;")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("a statement by you that you have a good faith belief that the\n        disputed use is not authorized by the copyright owner, its agent, or\n        the law;")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("a statement by you, made under penalty of perjury, that the above\n        information in your Notice is accurate and that you are the copyright\n        or intellectual property owner or authorized to act on the copyright\n        or intellectual property owner's behalf.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("'s")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        Copyright Agent can be reached at:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Email: ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("info@wanchain.org")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Subject Line: ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Copyright Notification Mail")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("11. BINDING ARBITRATION AND CLASS ACTION WAIVER")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("PLEASE READ THIS SECTION CAREFULLY – IT MAY SIGNIFICANTLY AFFECT YOUR\n        LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("13.1 Initial Dispute Resolution")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("The parties shall use their best efforts to engage directly to settle\n        any dispute, claim, question, or disagreement and engage in good faith\n        negotiations which shall be a condition to either party initiating a\n        lawsuit or arbitration.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("13.2 Binding Arbitration")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("If the parties do not reach an agreed upon solution within a period\n        of 30 days from the time informal dispute resolution under the Initial\n        Dispute Resolution provision begins, then either party may initiate\n        binding arbitration as the sole means to resolve claims, subject to\n        the terms set forth below. Specifically, all claims arising out of or\n        relating to these Terms (including their formation, performance and\n        breach), the parties’ relationship with each other and/or your use of\n        the Service shall be finally settled by binding arbitration\n        administered by the ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Singapore International Arbitration Centre")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        in accordance with the provisions of its Commercial Arbitration Rules\n        and the supplementary procedures for consumer related disputes of the ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Singapore International Arbitration Centre")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(", ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("excluding any rules or procedures governing or permitting class\n        actions. The arbitrator, and not any")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("court or agency, shall have exclusive authority to resolve all\n        disputes arising out of or relating to the interpretation,\n        applicability, enforceability or formation of these Terms, including,\n        but not limited to any claim that all or any part of these Terms are\n        void or voidable, or whether a claim is subject to arbitration. The\n        arbitrator shall be empowered to grant whatever relief would be\n        available in a court under law or in equity. The arbitrator’s award\n        shall be written, and binding on the parties and may be entered as a\n        judgment in any court of competent jurisdiction. The parties\n        understand that, absent this mandatory provision, they would have the\n        right to sue in court and have a jury trial. They further understand\n        that, in some instances, the costs of arbitration could exceed the\n        costs of litigation and the right to discovery may be more limited in\n        arbitration than in court.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("13.3 Location")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Binding arbitration shall take place in ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Singapore")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(". You agree to submit to the personal jurisdiction of court in ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Singapore")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(", in order to compel arbitration, to stay proceedings pending\n        arbitration, or to confirm, modify, vacate or enter judgment on the\n        award entered by the arbitrator.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("13.4 Class Action Waiver")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("The parties further agree that any arbitration or other permitted\n        action shall be conducted in their individual capacities only and not\n        as a class action or other representative action, and the parties\n        expressly waive their right to file a class action or seek relief on a\n        class basis. YOU AND ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("IWAN")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS\n        INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY\n        PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. If any court or\n        arbitrator determines that the class action waiver set forth in this\n        paragraph is void or unenforceable for any reason or that an\n        arbitration can proceed on a class basis, then the arbitration\n        provision set forth above shall be deemed null and void in its\n        entirety and the parties shall be deemed to have not agreed to\n        arbitrate disputes.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("13.5 Exception - Litigation of Intellectual Property and Small Claims\n        Court Claims")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Notwithstanding the parties' decision to resolve all disputes through\n        arbitration, either party may bring an action in court to protect its\n        intellectual property rights (“intellectual property rights” means\n        patents, copyrights, moral rights, trademarks, and trade secrets, but\n        not privacy or publicity rights). Either party may also seek relief in\n        a small claims court for disputes or claims within the scope of that\n        court’s jurisdiction.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("13.6 30-Day Right to ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Opt")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" Out")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("You have the right to opt-out and not be bound by the arbitration and\n        class action waiver provisions set forth above by sending written\n        notice of your decision to opt-out via email at ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("info")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("@")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("wanchain")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(".")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("org")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(", with subject line ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("IWAN")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        LEGAL OPT OUT. The notice must be sent within 30 days of your first\n        use of the Service, whichever is later, otherwise you shall be bound\n        to arbitrate disputes in accordance with the terms of those\n        paragraphs. If you opt-out of these arbitration provisions, ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        also will not be bound by them.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("13.7 Changes to this Section")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        will provide 60-days’ notice of any changes to this section. Changes\n        will become effective on the 60th day, and will apply prospectively\n        only to any claims arising after the 60th day. For any dispute not\n        subject to arbitration you and ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        agree to submit to the personal and exclusive jurisdiction of and\n        venue in courts located in ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Singapore.")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        You further agree to accept service of process by mail, and hereby\n        waive any and all jurisdictional and venue defenses otherwise\n        available. The Terms and the relationship between you and ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        shall be governed by the laws of ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Singapore")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        without regard to conflict of law provisions.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("14. GENERAL INFORMATION")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("14.1 Entire Agreement")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("These Terms (and any additional terms, rules and conditions of\n        participation that ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        may post on the Service) constitute the entire agreement between you\n        and ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        with respect to the Service and supersedes any prior agreements, oral\n        or written, between you and ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(". In the event of a conflict between these Terms and the additional\n        terms, rules and conditions of participation, the latter will prevail\n        over the Terms to the extent of the conflict.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("14.2 Waiver and Severability of Terms")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("The failure of ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        to exercise or enforce any right or provision of the Terms shall not\n        constitute a waiver of such right or provision. If any provision of\n        the Terms is found by an arbitrator or court of competent jurisdiction\n        to be invalid, the parties nevertheless agree that the arbitrator or\n        court should endeavor to give effect to the parties' intentions as\n        reflected in the provision, and the other provisions of the Terms\n        remain in full force and effect.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("14.3 Statute of Limitations")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("You agree that regardless of any statute or law to the contrary, any\n        claim or cause of action arising out of or related to the use of the\n        Service or the Terms must be filed within one (1) year after such\n        claim or cause of action arose or be forever barred.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("14.4 Section Titles")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("The section titles in the Terms are for convenience only and have no\n        legal or contractual effect.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("14.5 Communications")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Users with questions, complaints or claims with respect to the\n        Service may contact us using the relevant contact information set\n        forth above.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("15. SOFTWARE LICENSE")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("All Rights Reserved. ")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n        is currently exploring the appropriate license structure and this will\n        be updated when a conclusion is reached.")])])])])
}]}

/***/ }),

/***/ 979:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 980:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistics"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("stats.title")))])])]), _vm._v(" "), _c('section', {
    staticClass: "chart-container"
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.apikey),
      callback: function($$v) {
        _vm.apikey = $$v
      },
      expression: "apikey"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }, _vm._l((_vm.periods), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.network),
      callback: function($$v) {
        _vm.network = $$v
      },
      expression: "network"
    }
  }, _vm._l((_vm.networks), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "comCont clumW",
    attrs: {
      "span": 23,
      "empty-text": _vm.$t('common.noData')
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "comCont clum",
    attrs: {
      "empty-text": _vm.$t('common.noData')
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "comCont clum"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartBar"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "comCont clum"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartHeatmap"
    }
  })])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-bg"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "user-logo",
    attrs: {
      "src": __webpack_require__(76)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("resetPwd.title")))]), _vm._v(" "), _c('div', {
    staticClass: "user-form"
  }, [_c('el-form', [_c('el-form', {
    ref: "rstPwdForm",
    attrs: {
      "model": _vm.rstPwdForm,
      "status-icon": "",
      "rules": _vm.rstPwdRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('resetPwd.email')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.rstPwdForm.email),
      callback: function($$v) {
        _vm.$set(_vm.rstPwdForm, "email", $$v)
      },
      expression: "rstPwdForm.email"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.getVerifyCode
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t("common.sendCode")))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "code",
      "label": _vm.$t('common.verifyCode')
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.rstPwdForm.code),
      callback: function($$v) {
        _vm.$set(_vm.rstPwdForm, "code", $$v)
      },
      expression: "rstPwdForm.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("resetPwd.reset")))])], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "signUp"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("resetPwd.back")) + "\n      "), _c('router-link', {
    staticClass: "go-regi",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("resetPwd.login")))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 982:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "i-footer"
  }, [_c('p', {
    staticClass: "byP"
  }, [_vm._v(_vm._s(_vm.$t("index.copyright")))])])
},staticRenderFns: []}

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-bg"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "user-logo",
    attrs: {
      "src": __webpack_require__(76)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("login.title")))]), _vm._v(" "), _c('div', {
    staticClass: "user-form"
  }, [_c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "status-icon": "",
      "rules": _vm.loginRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "user",
      "label": _vm.$t('login.user')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "user"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.user),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "user", $$v)
      },
      expression: "loginForm.user"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": _vm.$t('login.password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "submitBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("login.login")))]), _vm._v(" "), _c('recaptcha', {
    ref: "recaptcha",
    on: {
      "verify": _vm.submit
    }
  })], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "go-fgtpwd",
    attrs: {
      "to": "/forgotpassword"
    }
  }, [_vm._v(_vm._s(_vm.$t("login.forgotPwd")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "signUp"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("login.notMember")) + "\n        "), _c('router-link', {
    staticClass: "go-regi",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t("login.signup")))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 984:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-container"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("changeEmail.title")))])])]), _vm._v(" "), _c('div', {
    staticClass: "cp-container"
  }, [_c('section', [_c('el-form', {
    ref: "chgEmailForm",
    attrs: {
      "model": _vm.chgEmailForm,
      "status-icon": "",
      "rules": _vm.chgEmailRule,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('changeEmail.password'),
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgEmailForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.chgEmailForm, "pass", $$v)
      },
      expression: "chgEmailForm.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('changeEmail.newEmail')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgEmailForm.email),
      callback: function($$v) {
        _vm.$set(_vm.chgEmailForm, "email", $$v)
      },
      expression: "chgEmailForm.email"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.getVerifyCode
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t("common.sendCode")))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "code",
      "label": _vm.$t('common.verifyCode')
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgEmailForm.code),
      callback: function($$v) {
        _vm.$set(_vm.chgEmailForm, "code", $$v)
      },
      expression: "chgEmailForm.code"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "cp-Btn",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 986:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users-container"
  }, [_c('section', [_c('el-col', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("admin.users")))])])]), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "60px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('admin.searchUser'),
      "icon": "search",
      "on-icon-click": _vm.searchUser
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchUser.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.users,
      "empty-text": _vm.$t('common.noData'),
      "highlight-current-row": "",
      "min-width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": _vm.$t('accountInfo.username')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.projectList(scope.row.username)
            }
          }
        }, [_vm._v(_vm._s(scope.row.username))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('accountInfo.email')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": _vm.$t('accountInfo.role')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": _vm.$t('accountInfo.registerDate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('common.operation')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "on-value": "normal",
            "off-value": "disabled",
            "on-color": "#13ce66",
            "off-color": "#cdcdcd",
            "disabled": scope.row.role === 'admin'
          },
          on: {
            "change": function($event) {
              return _vm.setUser(scope.row)
            }
          },
          model: {
            value: (scope.row.status),
            callback: function($$v) {
              _vm.$set(scope.row, "status", $$v)
            },
            expression: "scope.row.status"
          }
        }), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin": "0 0 0 20px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.userStats(scope.row.uid, scope.row.username)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("stats.title")))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.curPage,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "update:currentPage": function($event) {
        _vm.curPage = $event
      },
      "update:current-page": function($event) {
        _vm.curPage = $event
      },
      "size-change": _vm.changePageSize,
      "current-change": _vm.jumpPage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "EndpointBox",
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.$t("admin.totalUsers")) + "\n        "), _c('span', [_vm._v(_vm._s(_vm.totalUsers))]), _vm._v(_vm._s(_vm.$t("admin.totalProjects")) + "\n        "), _c('span', [_vm._v(_vm._s(_vm.totalProjects))])])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(76),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 10
    }
  }, [_c('el-menu', {
    staticClass: "docMenu3",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("index.documentation")))])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "../../static/apidoc/docs.html",
      "target": "_blank"
    }
  }, [_vm._v("API")])]), _vm._v(" "), _c('el-submenu', {
    staticClass: "subMenu",
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("SDK")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-js-sdk",
      "target": "_blank"
    }
  }, [_vm._v("JavaScript")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-java-sdk",
      "target": "_blank"
    }
  }, [_vm._v("Java")])])], 2)], 2)], 1), _vm._v(" "), _c('el-dropdown-item', {
    staticClass: "logout",
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("index.logout")))])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "theme": "dark",
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (_vm.isVisible(item)) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v("\n              " + _vm._s(_vm.$t(item.title)) + "\n            ")]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(_vm.$t(child.title)))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v("\n            " + _vm._s(_vm.$t(item.children[0].title)) + "\n          ")]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px",
        "color": "#dadada!important"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t(child.name)))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "color": "#dadada!important",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 988:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-recaptcha",
    attrs: {
      "id": "g-recaptcha",
      "data-sitekey": _vm.sitekey,
      "data-badge": "inline"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "i-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loginBtn"
  }, [_c('el-menu', {
    staticClass: "docMenu",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("index.documentation")))])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "../../static/apidoc/docs.html",
      "target": "_blank"
    }
  }, [_vm._v("API")])]), _vm._v(" "), _c('el-submenu', {
    staticClass: "subMenu",
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("SDK")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-js-sdk",
      "target": "_blank"
    }
  }, [_vm._v("JavaScript")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-java-sdk",
      "target": "_blank"
    }
  }, [_vm._v("Java")])])], 2)], 2)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "login",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.login")))]), _vm._v(" "), _c('router-link', {
    staticClass: "goRe",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.signup")))])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(76),
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 990:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('iHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('iFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("PRIVACY POLICY")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Last Updated:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("February")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("25, 201")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("This privacy policy (“Policy”) describes how")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Wanchain Foundation")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("’s")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("IWan")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("(“")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("IWan")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          ” “Company”, “we”, “our”, or “us”) collects, uses, shares, and stores\n          personal information of users of this website,\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "#ffff00",
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("https://")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "#ffff00",
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("iWan")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "#ffff00",
      "color": "#ff0000",
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(".io/")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          (the “Site”). This Policy applies to the Site, applications, products\n          and services (collectively, “Services”) on or in which it is posted,\n          linked, or referenced.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          By using the Services, you accept the terms of this Policy and our\n          Terms of Use, and consent to our collection, use, disclosure, and\n          retention of your information as described in this Policy. If you have\n          not done so already, please also review our terms of use. The terms of\n          use contain provisions that limit our liability to you and require you\n          to resolve any dispute with us on an individual basis and not as part\n          of any class or representative action. IF YOU DO NOT AGREE WITH ANY\n          PART OF THIS PRIVACY POLICY OR OUR TERMS OF USE, THEN PLEASE DO NOT\n          USE ANY OF THE SERVICES.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Please note that this Policy does not apply to information collected\n          through third-party websites or services that you may access through\n          the Services or that you submit to us through email, text message or\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("other")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("electronic message or offline.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          If you are visiting this site from the European Union (EU), see our\n          Notice to EU Data Subjects below for our legal bases for processing\n          and transfer of your data.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("WHAT WE COLLECT")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("We get information about you in a range of ways.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Information You Give Us.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Information we collect from you includes:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "disc"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Wanchain")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Account Addresses.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Identity information, such as your first name and last name;")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Contact information, such as your email address;")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n            Profile information, such as your application programming interface\n            (API)-key;\n          ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n            Feedback and correspondence, such as information you provide in\n            your responses to surveys, when you participate in market research\n            activities, report a problem with Service, receive customer support\n            or otherwise correspond with us;\n          ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n            Usage information, such as information about how you use the\n            Service and interact with us; and\n          ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n            Marketing information, such your preferences for receiving\n            marketing communications and details about how you engage with\n            them.\n          ")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Information We Get")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Others.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("We may get information about you from other")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("third party")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          sources and we may add this to information we get from your use of the\n          Services. Such information may include:\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "disc"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Social Media Widgets:")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Our Site may include social media features, such as the Facebook\n          “like” button and widgets, such as the “share this” button. These\n          features may collect your personal information and track your use of\n          the Site. These social media features are either hosted by a third\n          party or hosted directly on our Site. Your interactions with these\n          features are governed by the privacy policy of the company providing\n          such functionality.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Information Automatically Collected.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may automatically record certain information about how you use our\n          Site (we refer to this information as “Log\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Data“")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          ). Log Data may include information such as a user’s Internet\n          Protocol (IP) address, device and browser type, operating system, the\n          pages or features of our Site to which a user browsed and the time\n          spent on those pages or features, the frequency with which the Site is\n          used by a user, search terms, the links on our Site that a user\n          clicked on or used, and other statistics. We use this information to\n          administer the Service and we analyze (and may engage third parties to\n          analyze) this information to improve and enhance the Service by\n          expanding its features and functionality and tailoring it to our\n          users’ needs and preferences.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may use cookies or similar technologies to analyze trends,\n          administer the website, track users’ movements around the website, and\n          to gather demographic information about our user base as a whole.\n          Users can control the use of cookies at the individual browser level.\n          For more information, please see the section entitled “Cookies Policy”\n          below.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("We")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("may")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          use Google Analytics to help us offer you an optimized user\n          experience. You can find more information about Google Analytics’ use\n          of your personal data here:\n          https://policies.google.com/privacy?hl=en\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Information we will never collect. We will never ask you to share\n          your private keys or wallet seed. Never trust anyone or any site that\n          asks you to enter your private keys or wallet seed.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("USER OF PERSONAL INFORMATION")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("To provide our service")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We will use your personal information in the following ways: To\n          enable you to access and use the Services To provide and deliver\n          products and services that you may request. To send information,\n          including confirmations, technical notices, updates, security alerts,\n          and support and administrative messages.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("To comply with law")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We use your personal information as we believe necessary or\n          appropriate to comply with applicable laws, lawful requests and legal\n          process, such as to respond to subpoenas or requests from government\n          authorities.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("To communicate with you")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We use your personal information to communicate about promotions,\n          upcoming events, and other news about products and services offered by\n          us and our selected partners.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("To optimize our platform")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          In order to optimize your user experience, we may use your personal\n          information to operate, maintain, and improve our Services. We may\n          also use your information to respond to your comments and questions\n          regarding the Services, and to provide you and other users with\n          general customer service.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("With your consent")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may use or share your personal information with your consent, such\n          as when you consent to let us post your testimonials or endorsements\n          on our Site, you instruct us to take a specific action with respect to\n          your personal information, or you opt into third party marketing\n          communications.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("For compliance, fraud prevention, and safety")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may use your personal information to protect, investigate, and\n          deter against fraudulent, unauthorized, or illegal activity.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("SHARING OF PERSONAL INFORMATION")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We do not share or sell the personal information that you provide us\n          with other organizations without your express consent, except as\n          described in this Privacy Policy. We disclose personal information to\n          third parties under the following circumstances:\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Affiliates.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may disclose your personal information to our subsidiaries and\n          corporate affiliates for purposes consistent with this Privacy\n          Policy.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Business Transfers.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may share personal information when we do a business deal, or\n          negotiate a business deal, involving the sale or transfer of all or a\n          part of our business or assets. These deals can include any merger,\n          financing, acquisition, or bankruptcy transaction or proceeding.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("\n          Compliance with Laws and Law Enforcement; Protection and\n          Safety.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may share personal information for legal, protection, and safety\n          purposes.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("We may share information to comply with laws.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may share information to respond to lawful requests and legal\n          processes.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may share information to protect the rights and property of the\n          Company, our agents, customers, and others. This includes enforcing\n          our agreements, policies, and terms of use.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may share information in an emergency. This includes protecting\n          the safety of our employees and agents, our customers, or any\n          person.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Professional Advisors and Service Providers")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may share information with those who need it to do work for us.\n          These recipients may include third party companies and individuals to\n          administer and provide the Service on our behalf (such as customer\n          support, hosting, email delivery and database management services), as\n          well as lawyers, bankers, auditors, and insurers.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Other.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          You may permit us to share your personal information with other\n          companies or entities of your choosing. Those uses will be subject to\n          the privacy policies of the recipient entity or entities.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may also share aggregated and/or anonymized data with others for\n          their own uses.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("INTERNATIONAL TRANSFER")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          The Company has offices outside of the EU and has affiliates and\n          service providers in the United States and in other countries. Your\n          personal information may be transferred to or from the United States\n          or other locations outside of your state, province, country or other\n          governmental jurisdiction where privacy laws may not be as protective\n          as those in your jurisdiction.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          EU users should read the important information provided below about\n          transfer of personal information outside of the European Economic Area\n          (EEA).\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("HOW INFORMATION IS SECURED")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We retain information we collect as long as it is necessary and\n          relevant to fulfill the purposes outlined in this privacy policy. In\n          addition, we retain personal information to comply with applicable law\n          where required, prevent fraud, resolve disputes, troubleshoot\n          problems, assist with any investigation, enforce our Terms of Use, and\n          other actions permitted by law. To determine the appropriate retention\n          period for personal information, we consider the amount, nature, and\n          sensitivity of the personal information, the potential risk of harm\n          from unauthorized use or disclosure of your personal information, the\n          purposes for which we process your personal information and whether we\n          can achieve those purposes through other means, and the applicable\n          legal requirements.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          In some circumstances we may anonymize your personal information (so\n          that it can no longer be associated with you) in which case we may use\n          this information indefinitely without further notice to you.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We employ industry standard security measures designed to protect the\n          security of all information submitted through the Services. However,\n          the security of information transmitted through the internet can never\n          be guaranteed. We are not responsible for any interception or\n          interruption of any communications through the\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          internet or for changes to or losses of data. Users of the Services\n          are responsible for maintaining the security of any password,\n          biometrics, user ID or other form of authentication involved in\n          obtaining access to password protected or secure areas of any of our\n          digital services. In order to protect you and your data, we may\n          suspend your use of any of the Services, without notice, pending an\n          investigation, if any breach of security is suspected.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("INFORMATION CHOICES AND CHANGES")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Accessing, Updating, Correcting, and Deleting your Information")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          You may access information that you have voluntarily provided through\n          your account on the Services, and to review, correct, or delete it by\n          sending a request to\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("info@wanchain.org")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          . You can request to change contact choices, opt-out of our sharing\n          with others, and update your personal information and\n          preferences.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Tracking Technologies Generally")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Regular cookies may generally be disabled or removed by tools\n          available as part of most commercial browsers, and in some instances\n          blocked in the future by selecting certain settings. For more\n          information, please see the section entitled “Cookies Policy”\n          below.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Google Analytics")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("In case we")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("use Google Analytics")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("y")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          ou may exercise choices regarding the use of cookies from Google\n          Analytics by going to https://tools.google.com/dlpage/gaoptout and\n          downloading the Google Analytics Opt-out Browser Add-on.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("CONTACT INFORMATION.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We welcome your comments or questions about this Policy, and you may\n          contact us at:\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("info@wanchain.org")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("CHANGES TO THIS PRIVACY POLICY.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may change this privacy policy at any time. We encourage you to\n          periodically review this page for the latest information on our\n          privacy practices. If we make any changes, we will change the Last\n          Updated date above.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Any modifications to this Privacy Policy will be effective upon our\n          posting of the new terms and/or upon implementation of the changes to\n          the Site (or as otherwise indicated at the time of posting). In all\n          cases, your continued use of the\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Site or Services after the posting of any modified Privacy Policy\n          indicates your acceptance of the terms of the modified Privacy\n          Policy.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("ELIGIBILITY")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          If you are under the age of majority in your jurisdiction of\n          residence, you may use the Services only with the consent of or under\n          the supervision of your parent or legal guardian. Consistent with the\n          requirements of the Children's Online Privacy Protection Act (COPPA),\n          if we learn that we have received any information directly from\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          a child under age 13 without first receiving his or her parent's\n          verified consent, we will use that information only to respond\n          directly to that child (or his or her parent or legal guardian) to\n          inform the child that he or she cannot use the Site and subsequently\n          we will delete that information.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("NOTICE TO CALIFORNIA RESIDENTS")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Under California Civil Code Section 1789.3, California users are\n          entitled to the following consumer rights notice: California residents\n          may reach the Complaint Assistance Unit of the Division of Consumer\n          Services of the California Department of Consumer Affairs by mail at\n          1625 North Market Blvd., Sacramento, CA 95834, or by telephone at\n          (916) 445-1254 or (800) 952-5210.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("NOTICE TO EU DATA SUBJECTS")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Personal Information")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          With respect to EU data subjects, “personal information,” as used in\n          this Privacy Policy, is equivalent to “personal data” as defined in\n          the European Union General Data Protection Regulation (GDPR).\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Sensitive Data")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Some of the information you provide us may constitute sensitive data\n          as defined in the GDPR (also referred to as special categories of\n          personal data), including identification of your race or ethnicity on\n          government-issued identification documents.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Legal Bases for Processing")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We only use your personal information as permitted by law. We are\n          required to inform you of the legal bases of our processing of your\n          personal information, which are described in the table below. If you\n          have questions about the legal bases under which we process your\n          personal information, contact us at\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("info@wanchain.org")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "margin-left": "0pt"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "250.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("PROCESSING PURPOSE")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "250.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("LEGAL BASIS")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "250.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("To communicate with you")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("To optimize our platform")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("For compliance, fraud prevention, and safety")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("To provide our service")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "250.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("These processing activities")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("constitute")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n                our legitimate interests. We make sure we consider and balance\n                any potential impacts on you (both positive and negative) and\n                your rights before we process your personal information for our\n                legitimate interests. We do not use your personal information\n                for activities where our interests are overridden by any adverse\n                impact on you (unless we have your consent or are otherwise\n                required or permitted to by law).\n              ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "250.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("With your consent")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom-color": "#000000",
      "border-bottom-style": "solid",
      "border-bottom-width": "0.75pt",
      "border-left-color": "#000000",
      "border-left-style": "solid",
      "border-left-width": "0.75pt",
      "border-right-color": "#000000",
      "border-right-style": "solid",
      "border-right-width": "0.75pt",
      "border-top-color": "#000000",
      "border-top-style": "solid",
      "border-top-width": "0.75pt",
      "padding-left": "5.03pt",
      "padding-right": "5.03pt",
      "vertical-align": "top",
      "width": "250.6pt"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n                Where our use of your personal information is based upon your\n                consent, you have the right to withdraw it anytime in the manner\n                indicated in the Service or by contacting us at\n                info@wanchain.org.\n              ")])])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Use for New Purposes")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may use your personal information for reasons not described in\n          this Privacy Policy, where we are permitted by law to do so and where\n          the reason is compatible with the purpose for which we collected it.\n          If we need to use your personal information for an unrelated purpose,\n          we will notify you and explain the applicable legal basis for that\n          use. If we have relied upon your consent for a particular use of your\n          personal information, we will seek your consent for any unrelated\n          purpose.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Your Rights")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Under the GDPR, you have certain rights regarding your personal\n          information. You may ask us to take the following actions in relation\n          to your personal information that we hold:\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Opt-out.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Stop sending you direct marketing communications which you have\n          previously consented to receive. We may continue to send you\n          Service-related and other non-marketing communications.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Access.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Provide you with information about our processing of your personal\n          information and give you access to your personal information.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Correct.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Update or correct inaccuracies in your personal information.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Delete.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Delete your personal information.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Transfer.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Transfer a machine-readable copy of your personal information to you\n          or a third party of your choice.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Restrict.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Restrict the processing of your personal information.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Object.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Object to our reliance on our legitimate interests as the basis of\n          our processing of your personal information that impacts your\n          rights.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("You can submit these requests by email to")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("info@wanchain.org")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          . We may request specific information from you to help us confirm\n          your identity and process your request. Applicable law may require or\n          permit us to decline your request. If we decline your request, we will\n          tell you why, subject to legal restrictions. If you would like to\n          submit a complaint about our use of your personal information or\n          response to your requests regarding your personal information, you may\n          contact us at\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("info@wanchain.org")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          or submit a complaint to the data protection regulator in your\n          jurisdiction. You can find your data protection regulator here\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("(")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("http://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Cross-Border Data Transfer")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Please be aware that your personal data will be transferred to,\n          processed, and stored in the United States. Data\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          protection laws in the U.S. may be different from those in your\n          country of residence. You consent to the transfer of your information,\n          including personal information, to the U.S. as set forth in this\n          Privacy Policy by visiting our site or using our service.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Whenever we transfer your personal information out of the EEA to the\n          U.S. or countries not deemed by the European Commission to provide an\n          adequate level of personal information protection, the transfer will\n          be based on a data transfer mechanism recognized by the European\n          Commission as providing adequate protection for personal\n          information.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Please contact us if you want further information on the specific\n          mechanism used by us when transferring your personal information out\n          of the EEA.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("COOKIES POLICY")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We understand that your privacy is important to you and are committed\n          to being transparent about the technologies we use. In the spirit of\n          transparency, this policy provides detailed information about how and\n          when we use cookies on our Site.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Do we use Cookies?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Yes. We and our marketing partners, affiliates, and analytics or\n          service providers use cookies, web beacons, or pixels and other\n          technologies to ensure everyone who uses the Site has the best\n          possible experience.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("What is a Cookie?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          A cookie (“Cookie”) is a small text file that is placed on your hard\n          drive by a web page server. Cookies contain information that can later\n          be read by a web server in the domain that issued the cookie to you.\n          Some of the cookies will only be used if you use certain features or\n          select certain preferences, and some cookies will always be used. You\n          can find out more about each cookie by viewing our current cookie list\n          below. We update this list periodically, so there may be additional\n          cookies that are not yet listed. Web beacons, tags and scripts may be\n          used in the Site or in emails to help us to deliver cookies, count\n          visits, understand usage and campaign effectiveness and determine\n          whether an email has been opened and acted upon. We may receive\n          reports based on the use of these technologies by our\n          service/analytics providers on an individual and aggregated\n          basis.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("Why do we use Cookies?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("We generally use Cookies for the following purposes:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "disc"
    }
  }, [_c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("To recognize new or past customers.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("To store your password if you are registered on our Site.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n            To improve our Site and to better understand your visits on our\n            platforms and Site.\n          ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("To integrate with third party social media websites.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("To serve you with interest-based or targeted advertising.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 0pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n            To observe your behaviors and browsing activities over time across\n            multiple websites or other platforms.\n          ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-family": "serif",
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt 28.06pt",
      "orphans": "0",
      "padding-left": "7.94pt",
      "text-align": "justify",
      "text-indent": "0pt",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n            To better understand the interests of our customers and our website\n            visitors.\n          ")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Some Cookies are necessary for certain uses of the Site, and without\n          such Cookies, we would not be able to provide many services that you\n          need to properly use the Site. These Cookies, for example, allow us to\n          operate our Site so you may access it as you have requested and let us\n          recognize that you have created an account and have logged into that\n          account to access Site content. They also include Cookies that enable\n          us to remember your previous actions within the same browsing session\n          and secure our Sites.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We also use functional Cookies and Cookies from third parties for\n          analysis and marketing purposes. Functional Cookies enable certain\n          parts of the site to work properly and your user preferences to remain\n          known. Analysis Cookies, among other things, collect information on\n          how visitors use our Site, the content and products that users view\n          most frequently, and the effectiveness of our\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("third party")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          advertising. Advertising Cookies assist in delivering ads to relevant\n          audiences and having our ads appear at the top of search results.\n          Cookies are either “session” Cookies which are deleted when you end\n          your browser session, or “persistent,” which remain until their\n          deletion by you (discussed below) or the party who served the cookie.\n          Full details on all of the Cookies used on the Site are available at\n          our Cookie Disclosure table below.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt",
      "font-weight": "bold"
    }
  }, [_vm._v("How to disable Cookies.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          You can generally activate or later deactivate the use of cookies\n          through a functionality built into your web browser. To learn more\n          about how to control cookie settings through your browser:\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Learn")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          more about the “Private Browsing” setting and managing cookie settings\n          in Firefox;\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("Learn")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("more about “Incognito” and managing cookie settings in Chrome;")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("https://support.google.com/chrome/answer/95647?hl=en")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("L")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          earn more about “InPrivate” and managing cookie settings in Internet\n          Explorer; or\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("L")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          earn more about “Private Browsing” and managing cookie settings in\n          Safari.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("https://support.apple.com/kb/ph21411?locale=en_US")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          If you want to learn more about cookies, or how to control, disable\n          or delete them, please visit http://www.aboutcookies.org for detailed\n          guidance. In addition, certain\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("third party")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          advertising networks, including Google, permit users to opt out of or\n          customize preferences associated with your internet browsing.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          To control flash cookies, which we may use on our Site from time to\n          time, you can go to this link\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("(")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          because Flash cookies cannot be controlled through your browser\n          settings. Please note that if you decline the use of Cookies, some\n          functions of the website may be unavailable and we will not be able to\n          present personally tailored content and advertisements to you.\n        ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11pt",
      "line-height": "108%",
      "margin": "0pt 0pt 8pt",
      "orphans": "0",
      "text-align": "justify",
      "widows": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          We may link the information collected by Cookies with other\n          information we collect from you pursuant to this Privacy Policy and\n          use the combined information as set forth herein. Similarly, the third\n          parties who serve cookies on our Site may link your name or email\n          address to other information they collect, which may include past\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          purchases made offline or online, or your online usage information.\n          If you are located in the European Economic\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "等线",
      "font-size": "11pt"
    }
  }, [_vm._v("\n          Area, you have certain rights that are described above under the\n          header “Notice to EU Data Subjects”, including the right to inspect\n          and correct or delete the data that we have about you.\n        ")])])])])
}]}

/***/ })

},[532]);


// WEBPACK FOOTER //
// static/js/app.1c8f771eccea4b0f3f35.js